"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9583],{

/***/ 78807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addProductToCart": function() { return /* binding */ addProductToCart; },
/* harmony export */   "addServicesToCart": function() { return /* binding */ addServicesToCart; },
/* harmony export */   "addToCartError": function() { return /* binding */ addToCartError; },
/* harmony export */   "addToCartSuccess": function() { return /* binding */ addToCartSuccess; },
/* harmony export */   "buildCheckoutTrace": function() { return /* binding */ buildCheckoutTrace; },
/* harmony export */   "buildCommonEvent": function() { return /* binding */ buildCommonEvent; },
/* harmony export */   "buildServicesEventLabel": function() { return /* binding */ buildServicesEventLabel; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85942);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _utils_buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19777);
/* harmony import */ var _utils_gaEcommerceProduct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15950);
/* harmony import */ var _utils_productFormatter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67412);
/* harmony import */ var _utils_getTypeButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22078);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59075);








var addToCartError = function addToCartError(_ref) {
  var product = _ref.product,
    error = _ref.error;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    eventAction: 'add-to-cart:error',
    eventCategory: _constants__WEBPACK_IMPORTED_MODULE_5__.GENERAL_PRODUCT,
    eventLabel: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(error).toLowerCase(),
    eventNonInteraction: '1'
  }, (0,_utils_buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_1__["default"])(product));
};
var buildCheckoutTrace = function buildCheckoutTrace(_ref2) {
  var eventCategory = _ref2.eventCategory,
    typeButton = _ref2.typeButton;
  return "".concat(eventCategory, "->").concat(typeButton);
};
var buildCommonEvent = function buildCommonEvent() {
  var _structure$cookies, _structure$cookies$ac, _product$seller, _product$shipping, _product$shipping$, _product$shipping$$pa, _product$shipping$$pa2, _product$price;
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$product = _ref3.product,
    product = _ref3$product === void 0 ? {} : _ref3$product,
    services = _ref3.services,
    _ref3$location = _ref3.location,
    location = _ref3$location === void 0 ? {} : _ref3$location,
    _ref3$structure = _ref3.structure,
    structure = _ref3$structure === void 0 ? {} : _ref3$structure,
    eventId = _ref3.eventId;
  var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'geral';
  return {
    currency: _constants__WEBPACK_IMPORTED_MODULE_5__.CURRENCY,
    ecommerce: {
      add: {
        products: [(0,_utils_gaEcommerceProduct__WEBPACK_IMPORTED_MODULE_2__["default"])((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, product, {
          accountId: structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.id,
          id: product == null ? void 0 : product.variationId,
          location: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(location),
          overview: (0,_utils_productFormatter__WEBPACK_IMPORTED_MODULE_3__["default"])(services !== undefined ? {
            product: product,
            services: services
          } : product, formatter),
          shippingValues: (0,_utils_productFormatter__WEBPACK_IMPORTED_MODULE_3__["default"])(product, 'frete')
        }))]
      }
    },
    event: 'addToCart',
    eventAction: 'add-to-cart',
    eventId: eventId,
    eventNonInteraction: '0',
    produtoDisponivel: product == null ? void 0 : product.available,
    sellerEntrega: product == null ? void 0 : (_product$seller = product.seller) == null ? void 0 : _product$seller.deliveryId,
    tipoDeCliente: undefined,
    valorFrete: product == null ? void 0 : (_product$shipping = product.shipping) == null ? void 0 : (_product$shipping$ = _product$shipping[0]) == null ? void 0 : (_product$shipping$$pa = _product$shipping$.packages) == null ? void 0 : (_product$shipping$$pa2 = _product$shipping$$pa[0]) == null ? void 0 : _product$shipping$$pa2.price,
    value: parseFloat(product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.fullPrice)
  };
};
var buildServicesEventLabel = function buildServicesEventLabel(servicesId, services) {
  if (!(servicesId == null ? void 0 : servicesId.length)) return 'servico:nenhum';
  var selectedServices = services.reduce(function (acc, item) {
    var offerSelected = item == null ? void 0 : item.offers.filter(function (offer) {
      return servicesId.includes(offer.id);
    });
    return [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(acc), (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(offerSelected));
  }, []);
  return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .mapNestedKey */ .yC)(Object.values(selectedServices), 'description').map(function (desc) {
    return "servico:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(desc)).toLowerCase();
  }).join('|');
};
var addProductToCart = function addProductToCart(_ref4) {
  var location = _ref4.location,
    product = _ref4.product,
    typeButton = _ref4.typeButton,
    _ref4$structure = _ref4.structure,
    structure = _ref4$structure === void 0 ? {} : _ref4$structure,
    eventId = _ref4.eventId;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    eventCategory: _constants__WEBPACK_IMPORTED_MODULE_5__.GENERAL_PRODUCT,
    eventLabel: 'adicionar-a-sacola',
    inicioCheckout: buildCheckoutTrace({
      eventCategory: _constants__WEBPACK_IMPORTED_MODULE_5__.GENERAL_PRODUCT,
      typeButton: typeButton
    }),
    screenName: 'produto'
  }, buildCommonEvent({
    eventId: eventId,
    location: location,
    product: product,
    structure: structure
  }));
};
var addServicesToCart = function addServicesToCart(_ref5) {
  var location = _ref5.location,
    product = _ref5.product,
    services = _ref5.services,
    typeButton = _ref5.typeButton,
    eventId = _ref5.eventId;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    eventCategory: 'servico',
    eventLabel: buildServicesEventLabel(services, product == null ? void 0 : product.financialServices),
    inicioCheckout: buildCheckoutTrace({
      eventCategory: 'servico',
      typeButton: typeButton
    }),
    screenName: 'servico'
  }, buildCommonEvent({
    eventId: eventId,
    location: location,
    product: product,
    services: services
  }, 'service'));
};
var addToCartSuccess = function addToCartSuccess(_ref6) {
  var location = _ref6.location,
    product = _ref6.product,
    services = _ref6.services,
    defaultTypeButton = _ref6.typeButton;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var typeButton = (0,_utils_getTypeButton__WEBPACK_IMPORTED_MODULE_4__["default"])(defaultTypeButton);
  if (services !== undefined) return addServicesToCart((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    location: location,
    product: product,
    services: services,
    typeButton: typeButton
  }, args));
  return addProductToCart((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    location: location,
    product: product,
    typeButton: typeButton
  }, args));
};

/***/ }),

/***/ 97100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildBlogPageView": function() { return /* binding */ buildBlogPageView; }
/* harmony export */ });
var blogPageView = function blogPageView(_ref) {
  var structure = _ref.structure;
  return {
    clientId: structure == null ? void 0 : structure.cookies.clientId,
    device: structure == null ? void 0 : structure.device,
    event: 'virtualPageview',
    idParceiro: structure == null ? void 0 : structure.cookies.partnerId,
    idUsuario: structure == null ? void 0 : structure.cookies.customerId,
    pageType: "blog-".concat(structure == null ? void 0 : structure.id),
    screenName: "blog ".concat(structure == null ? void 0 : structure.name)
  };
};
var buildBlogPageView = function buildBlogPageView(_ref2) {
  var structure = _ref2.structure;
  var siteName = structure.site;
  if (siteName === 'blog' || siteName === 'blog-mobile') {
    return blogPageView({
      structure: structure
    });
  }
  return null;
};

/***/ }),

/***/ 6870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "postClick": function() { return /* binding */ postClick; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var postClick = function postClick(_ref, _ref2) {
  var title = _ref.title,
    categoryId = _ref.categoryId,
    recomendationLayout = _ref.recomendationLayout;
  var structure = _ref2.structure;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "blog:".concat(structure == null ? void 0 : structure.id, ":").concat(recomendationLayout),
    eventLabel: "post:".concat(categoryId, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(title))
  };
};

/***/ }),

/***/ 73191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "shareBlogButtonClick": function() { return /* binding */ shareBlogButtonClick; }
/* harmony export */ });
var shareBlogButtonClick = function shareBlogButtonClick(_ref, _ref2) {
  var socialName = _ref.socialName;
  var structure = _ref2.structure;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "blog-".concat(structure == null ? void 0 : structure.id, ":redes-sociais"),
    eventLabel: "".concat(socialName)
  };
};

/***/ }),

/***/ 31956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buyBoxButtonClick": function() { return /* binding */ buyBoxButtonClick; },
/* harmony export */   "buyBoxSeeMoreOffers": function() { return /* binding */ buyBoxSeeMoreOffers; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _utils_buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19777);


var buildBuyBoxImpression = function buildBuyBoxImpression() {
  return {
    content_id: 'veja-mais-ofertas-para-este-produto',
    content_type: 'produto',
    event: 'select_content'
  };
};
var buildBuyBoxButtonImpression = function buildBuyBoxButtonImpression(_ref) {
  var _structure$cookies, _structure$cookies$ac;
  var product = _ref.product,
    structure = _ref.structure;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    eventAction: 'add-to-cart:click',
    eventCategory: 'produto:geral',
    eventLabel: 'escolha-a-melhor-oferta',
    eventNonInteraction: '0'
  }, (0,_utils_buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_0__["default"])((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    accountId: structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.id
  }, product)));
};
var buyBoxButtonClick = function buyBoxButtonClick(_ref2) {
  var product = _ref2.product;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildBuyBoxButtonImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    product: product
  }, args));
};
var buyBoxSeeMoreOffers = function buyBoxSeeMoreOffers() {
  return buildBuyBoxImpression();
};

/***/ }),

/***/ 58346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buyButtonClick": function() { return /* binding */ buyButtonClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
/* harmony import */ var _utils_buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19777);
/* harmony import */ var _utils_getTypeButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22078);



var buildEventLabels = function buildEventLabels(type) {
  return type === 'typeFloat' ? {
    eventCategory: 'produto:flutuante',
    eventLabel: (0,_utils_getTypeButton__WEBPACK_IMPORTED_MODULE_1__["default"])('oneTouch')
  } : {
    eventCategory: 'produto:geral',
    eventLabel: (0,_utils_getTypeButton__WEBPACK_IMPORTED_MODULE_1__["default"])(type)
  };
};
var buildBuyButtonClick = function buildBuyButtonClick(_ref) {
  var _structure$cookies, _structure$cookies$ac;
  var _ref$structure = _ref.structure,
    structure = _ref$structure === void 0 ? {} : _ref$structure,
    product = _ref.product,
    typeButton = _ref.typeButton;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: 'clickEvent'
  }, buildEventLabels(typeButton), {
    eventAction: 'add-to-cart:click',
    eventNonInteraction: '0'
  }, (0,_utils_buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_0__["default"])((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, product, {
    accountId: structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.id
  })));
};
var buyButtonClick = function buyButtonClick(_ref2) {
  var product = _ref2.product,
    typeButton = _ref2.typeButton;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildBuyButtonClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    product: product,
    typeButton: typeButton
  }));
};

/***/ }),

/***/ 68789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buybuttonServicesOnClick": function() { return /* binding */ buybuttonServicesOnClick; }
/* harmony export */ });
var buybuttonServicesOnClick = function buybuttonServicesOnClick(_ref) {
  var _product$price, _product$price2;
  var product = _ref.product;
  return {
    basketId: undefined,
    currency: product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.currency,
    event: 'add_to_cart',
    eventAction: 'add-to-cart',
    eventCategory: 'sacola:produto',
    eventLabel: 'ver-produtos-e-precos',
    item: product,
    screenName: 'carrinho',
    value: Number((product == null ? void 0 : (_product$price2 = product.price) == null ? void 0 : _product$price2.fullPrice) || 0)
  };
};

/***/ }),

/***/ 59190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cardanChangeFormModel": function() { return /* binding */ cardanChangeFormModel; },
/* harmony export */   "cardanChangeFormPlateNumber": function() { return /* binding */ cardanChangeFormPlateNumber; },
/* harmony export */   "cardanChangeVehicleClick": function() { return /* binding */ cardanChangeVehicleClick; },
/* harmony export */   "cardanCleanSearch": function() { return /* binding */ cardanCleanSearch; },
/* harmony export */   "cardanProductAskSellerClick": function() { return /* binding */ cardanProductAskSellerClick; },
/* harmony export */   "cardanProductChangeVehicleClick": function() { return /* binding */ cardanProductChangeVehicleClick; },
/* harmony export */   "cardanProductView": function() { return /* binding */ cardanProductView; },
/* harmony export */   "cardanSearchModelClick": function() { return /* binding */ cardanSearchModelClick; },
/* harmony export */   "cardanSearchPlateNumberClick": function() { return /* binding */ cardanSearchPlateNumberClick; },
/* harmony export */   "cardanView": function() { return /* binding */ cardanView; }
/* harmony export */ });
var cardanChangeFormModel = function cardanChangeFormModel(data) {
  return {
    content_id: 'formulario-modelo',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    screenName: 'busca'
  };
};
var cardanChangeFormPlateNumber = function cardanChangeFormPlateNumber(data) {
  return {
    content_id: 'formulario-placa',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    screenName: 'busca'
  };
};
var cardanChangeVehicleClick = function cardanChangeVehicleClick(data) {
  return {
    content_id: 'alterar-veiculo',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    screenName: 'busca'
  };
};
var cardanCleanSearch = function cardanCleanSearch(data) {
  return {
    content_id: 'buscar-sem-veiculo',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    screenName: 'busca'
  };
};
var cardanProductAskSellerClick = function cardanProductAskSellerClick(data) {
  return {
    content_id: 'pergunte-ao-vendedor',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    item_id: data.sku,
    screenName: 'produto'
  };
};
var cardanProductChangeVehicleClick = function cardanProductChangeVehicleClick(data) {
  return {
    content_id: 'alterar-veiculo',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    item_id: data.sku,
    screenName: 'produto'
  };
};
var cardanProductView = function cardanProductView(data) {
  return {
    content_id: "cardan:".concat(data.mensagemRetorno),
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'view_content',
    item_id: data.sku,
    screenName: 'produto'
  };
};
var cardanSearchModelClick = function cardanSearchModelClick(data) {
  return {
    content_id: 'procurar',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    screenName: 'busca'
  };
};
var cardanSearchPlateNumberClick = function cardanSearchPlateNumberClick(data) {
  return {
    content_id: 'procurar-por-placa',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    screenName: 'busca'
  };
};
var cardanView = function cardanView(data) {
  return {
    content_id: 'cardan',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'view_content',
    screenName: 'busca'
  };
};

/***/ }),

/***/ 82378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clickFollowSellerEvent": function() { return /* binding */ clickFollowSellerEvent; }
/* harmony export */ });
var buildFollowSellerEvent = function buildFollowSellerEvent(isFollowing, sellerId) {
  return {
    content_id: isFollowing ? 'seguir' : 'nao-seguir',
    content_type: "chat-lojista:".concat(sellerId),
    event: 'select_content',
    mini_app_name: 'fale-lojista'
  };
};
var clickFollowSellerEvent = function clickFollowSellerEvent(_ref) {
  var isFollowing = _ref.isFollowing,
    sellerId = _ref.sellerId;
  return buildFollowSellerEvent(isFollowing, sellerId);
};

/***/ }),

/***/ 6450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "chatbotLuClick": function() { return /* binding */ chatbotLuClick; },
/* harmony export */   "chatbotLuImpression": function() { return /* binding */ chatbotLuImpression; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var buildChatBotEvent = function buildChatBotEvent(_ref) {
  var pagetype = _ref.pagetype;
  return {
    event: 'clickEvent',
    eventAction: 'impression',
    eventCategory: "".concat(pagetype, ":chatbot-lu"),
    eventLabel: 'chat',
    pagetype: pagetype
  };
};
var chatbotLuClick = function chatbotLuClick() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    pagetype = _ref2.pagetype;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, buildChatBotEvent({
    pagetype: pagetype
  }), {
    eventAction: 'click'
  });
};
var chatbotLuImpression = function chatbotLuImpression() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    pagetype = _ref3.pagetype;
  return buildChatBotEvent({
    pagetype: pagetype
  });
};

/***/ }),

/***/ 59075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CURRENCY": function() { return /* binding */ CURRENCY; },
/* harmony export */   "DELIVERY": function() { return /* binding */ DELIVERY; },
/* harmony export */   "GENERAL_PRODUCT": function() { return /* binding */ GENERAL_PRODUCT; }
/* harmony export */ });
var CURRENCY = 'BRL';
var DELIVERY = {
  delivery_24h: 'entrega-em-1-dia-util',
  delivery_plus_1: 'entrega-em-2-dias-uteis',
  magalu_indica: 'magalu-indica',
  'magalu-entregas': 'entregue-por-magalu',
  'magalu-partner': 'perto-de-voce',
  promocao_sazonal_1: 'ofertas-de-natal',
  promocao_sazonal_2: 'cupons',
  promocao_sazonal_3: 'super-ofertas',
  promocao_sazonal_4: 'ofertas-fantasticas',
  store_pickup_available: 'retira-na-loja'
};
var GENERAL_PRODUCT = 'produto:geral';

/***/ }),

/***/ 7779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var buildContinueToCartImpression = function buildContinueToCartImpression(data) {
  var _data$shipping, _data$shipping$, _data$shipping$$packa, _data$shipping2, _data$shipping2$, _data$shipping2$$pack, _data$shipping2$$pack2, _data$shipping2$$pack3, _data$category, _data$seller, _data$seller2, _data$seller3, _data$seller4, _data$subcategory;
  var shippingPackage = (data == null ? void 0 : (_data$shipping = data.shipping) == null ? void 0 : (_data$shipping$ = _data$shipping[0]) == null ? void 0 : (_data$shipping$$packa = _data$shipping$.packages) == null ? void 0 : _data$shipping$$packa[0]) || {};
  var hasPickupStore = !!(data == null ? void 0 : (_data$shipping2 = data.shipping) == null ? void 0 : (_data$shipping2$ = _data$shipping2[0]) == null ? void 0 : (_data$shipping2$$pack = _data$shipping2$.packages) == null ? void 0 : (_data$shipping2$$pack2 = _data$shipping2$$pack[0]) == null ? void 0 : (_data$shipping2$$pack3 = _data$shipping2$$pack2.deliveryTypes) == null ? void 0 : _data$shipping2$$pack3.some(function (el) {
    return el.type === 'store_pickup';
  }));
  return {
    categorias: data == null ? void 0 : (_data$category = data.category) == null ? void 0 : _data$category.id,
    categoriaSeller: data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.category,
    event: 'clickEvent',
    eventAction: 'add-to-cart:click',
    eventCategory: 'home:continuar-compra',
    eventLabel: 'continuar-sua-compra',
    eventNonInteraction: '0',
    freteTotal: shippingPackage == null ? void 0 : shippingPackage.price,
    nomeSeller: data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.id,
    produtoClube: (data == null ? void 0 : (_data$seller3 = data.seller) == null ? void 0 : _data$seller3.discounts) ? 'verdadeiro' : 'falso',
    produtoDisponivel: (data == null ? void 0 : data.available) ? 'verdadeiro' : 'falso',
    produtoFavoritado: undefined,
    retiraLoja: hasPickupStore ? 'verdadeiro' : 'falso',
    sellerEntrega: data == null ? void 0 : (_data$seller4 = data.seller) == null ? void 0 : _data$seller4.id,
    sku: data == null ? void 0 : data.id,
    subcategorias: data == null ? void 0 : (_data$subcategory = data.subcategory) == null ? void 0 : _data$subcategory.id
  };
};
var continueToCart = function continueToCart(_ref) {
  var product = _ref.product;
  return buildContinueToCartImpression(product);
};
/* harmony default export */ __webpack_exports__["default"] = (continueToCart);

/***/ }),

/***/ 71330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "didYouMeanSelect": function() { return /* binding */ didYouMeanSelect; },
/* harmony export */   "didYouMeanView": function() { return /* binding */ didYouMeanView; }
/* harmony export */ });
var contentType = 'busca';
var didYouMeanSelect = function didYouMeanSelect(_ref) {
  var raw = _ref.raw,
    refined = _ref.refined;
  return {
    content_id: refined,
    content_type: contentType,
    event: 'select_content',
    raw: raw
  };
};
var didYouMeanView = function didYouMeanView(_ref2) {
  var raw = _ref2.raw,
    refined = _ref2.refined;
  return {
    content_id: refined,
    content_type: contentType,
    event: 'view_content',
    raw: raw
  };
};

/***/ }),

/***/ 1602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27903);



var displayType = function displayType() {
  var _args$structure, _args$structure$cooki, _args$structure2, _args$structure3, _args$structure3$rout, _args$structure4, _args$structure4$rout, _args$structure5, _args$structure5$rout, _args$structure6, _args$structure6$rout, _args$data;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (data == null ? void 0 : data.label) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    cidadeuf: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(args == null ? void 0 : (_args$structure = args.structure) == null ? void 0 : (_args$structure$cooki = _args$structure.cookies) == null ? void 0 : _args$structure$cooki.location),
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "".concat((args == null ? void 0 : (_args$structure2 = args.structure) == null ? void 0 : _args$structure2.name) || '', ":grid"),
    eventLabel: data.label,
    eventNonInteraction: '0',
    pageCategory: (args == null ? void 0 : (_args$structure3 = args.structure) == null ? void 0 : (_args$structure3$rout = _args$structure3.route) == null ? void 0 : _args$structure3$rout.categoryId) || 'nao-se-aplica',
    pageSubcategory: (args == null ? void 0 : (_args$structure4 = args.structure) == null ? void 0 : (_args$structure4$rout = _args$structure4.route) == null ? void 0 : _args$structure4$rout.subCategoryId) || 'nao-se-aplica',
    termoBuscado: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)(args == null ? void 0 : (_args$structure5 = args.structure) == null ? void 0 : (_args$structure5$rout = _args$structure5.route) == null ? void 0 : _args$structure5$rout.term),
    termoDigitado: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)(args == null ? void 0 : (_args$structure6 = args.structure) == null ? void 0 : (_args$structure6$rout = _args$structure6.route) == null ? void 0 : _args$structure6$rout.term)
  }, (args == null ? void 0 : (_args$data = args.data) == null ? void 0 : _args$data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_2__["default"])(args.data.channel)));
};
/* harmony default export */ __webpack_exports__["default"] = (displayType);

/***/ }),

/***/ 64056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildFilterClick": function() { return /* binding */ buildFilterClick; },
/* harmony export */   "fastFilterClick": function() { return /* binding */ fastFilterClick; },
/* harmony export */   "fastFilterView": function() { return /* binding */ fastFilterView; },
/* harmony export */   "filterClean": function() { return /* binding */ filterClean; },
/* harmony export */   "filterClose": function() { return /* binding */ filterClose; },
/* harmony export */   "filterDeliveryClear": function() { return /* binding */ filterDeliveryClear; },
/* harmony export */   "filterDeliverySelect": function() { return /* binding */ filterDeliverySelect; },
/* harmony export */   "filterItemClick": function() { return /* binding */ filterItemClick; },
/* harmony export */   "filterLinkListClick": function() { return /* binding */ filterLinkListClick; },
/* harmony export */   "filterOpen": function() { return /* binding */ filterOpen; },
/* harmony export */   "filterRemove": function() { return /* binding */ filterRemove; },
/* harmony export */   "filterTypeClick": function() { return /* binding */ filterTypeClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59740);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27903);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59075);


var _excluded = ["eventLabel", "eventAction"];



var buildFilterClick = function buildFilterClick(_ref) {
  var data = _ref.data,
    _ref$eventLabel = _ref.eventLabel,
    eventLabel = _ref$eventLabel === void 0 ? '' : _ref$eventLabel,
    _ref$eventCategory = _ref.eventCategory,
    eventCategory = _ref$eventCategory === void 0 ? 'filtro' : _ref$eventCategory,
    _ref$eventAction = _ref.eventAction,
    eventAction = _ref$eventAction === void 0 ? 'click' : _ref$eventAction,
    structure = _ref.structure;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: 'clickEvent',
    eventAction: eventAction,
    eventCategory: "".concat((structure == null ? void 0 : structure.name) || '', ":").concat(eventCategory),
    eventLabel: eventLabel,
    eventNonInteraction: '0'
  }, (data == null ? void 0 : data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_3__["default"])(data.channel)));
};
var filterItemClickLabel = function filterItemClickLabel(custom, selected) {
  if (custom) return 'selecionar';
  return "".concat(selected ? 'remover' : 'adicionar', "-filtro");
};
var filterDeliveryClick = function filterDeliveryClick(_ref2) {
  var _args$structure, _args$structure$cooki;
  var _ref2$eventLabel = _ref2.eventLabel,
    eventLabel = _ref2$eventLabel === void 0 ? '' : _ref2$eventLabel,
    eventAction = _ref2.eventAction,
    args = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref2, _excluded);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    cidadeuf: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(args == null ? void 0 : (_args$structure = args.structure) == null ? void 0 : (_args$structure$cooki = _args$structure.cookies) == null ? void 0 : _args$structure$cooki.location)
  }, buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: eventAction,
    eventCategory: 'delivery',
    eventLabel: _constants__WEBPACK_IMPORTED_MODULE_1__.DELIVERY[eventLabel || '']
  })));
};
var fastFilterClick = function fastFilterClick() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    filterLabel = _ref3.filterLabel,
    filterValue = _ref3.slug;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: 'click',
    eventCategory: "filtro-rapido",
    eventLabel: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(filterLabel), ":").concat(filterValue)
  }));
};
var fastFilterView = function fastFilterView() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    eventLabel = _ref4.eventLabel;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: 'impression',
    eventCategory: "filtro-rapido",
    eventLabel: eventLabel
  }));
};
var filterClean = function filterClean() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventLabel: 'limpar-tudo'
  }));
};
var filterClose = function filterClose() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventLabel: 'fechar'
  }));
};
var filterDeliveryClear = function filterDeliveryClear() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return filterDeliveryClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: 'limpar'
  }));
};
var filterDeliverySelect = function filterDeliverySelect() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return filterDeliveryClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: 'aplicar'
  }));
};
var filterItemClick = function filterItemClick() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    filterLabel = _ref5.filterLabel,
    _ref5$position = _ref5.position,
    position = _ref5$position === void 0 ? '' : _ref5$position,
    label = _ref5.label,
    _ref5$selected = _ref5.selected,
    selected = _ref5$selected === void 0 ? false : _ref5$selected,
    _ref5$searchTerm = _ref5.searchTerm,
    searchTerm = _ref5$searchTerm === void 0 ? '' : _ref5$searchTerm,
    _ref5$custom = _ref5.custom,
    custom = _ref5$custom === void 0 ? false : _ref5$custom;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: "".concat(position, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(filterLabel)),
    eventLabel: "".concat(filterItemClickLabel(custom, selected), ":").concat(position || '', ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label)).concat(searchTerm && ":".concat(searchTerm))
  }));
};
var filterLinkListClick = function filterLinkListClick() {
  var _args$structure2;
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    label = _ref6.label;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var pathName = (args == null ? void 0 : (_args$structure2 = args.structure) == null ? void 0 : _args$structure2.name) || '';
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventCategory: 'consultas-relacionadas',
    eventLabel: "".concat(pathName, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label))
  }));
};
var filterOpen = function filterOpen() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventLabel: 'abrir'
  }));
};
var filterRemove = function filterRemove() {
  var _args$structure3;
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    position = _ref7.position,
    label = _ref7.label;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _args$structure$route = args == null ? void 0 : (_args$structure3 = args.structure) == null ? void 0 : _args$structure3.route,
    _args$structure$route2 = _args$structure$route.term,
    term = _args$structure$route2 === void 0 ? '' : _args$structure$route2;
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: "".concat(position, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label)),
    eventLabel: "remover-filtro-busca:".concat(position, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label)).concat(term && ":".concat(term))
  }));
};
var filterTypeClick = function filterTypeClick() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref8$label = _ref8.label,
    label = _ref8$label === void 0 ? '' : _ref8$label,
    _ref8$position = _ref8.position,
    position = _ref8$position === void 0 ? '' : _ref8$position;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: "".concat(position, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label)),
    eventLabel: "selecionar-categoria:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label))
  }));
};

/***/ }),

/***/ 75088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "financialServicesSeparateAddToCart": function() { return /* binding */ financialServicesSeparateAddToCart; },
/* harmony export */   "financialServicesSeparateSaleDetailsOnClick": function() { return /* binding */ financialServicesSeparateSaleDetailsOnClick; },
/* harmony export */   "financialServicesSeparateSaleOnChange": function() { return /* binding */ financialServicesSeparateSaleOnChange; },
/* harmony export */   "financialServicesSeparateSaleOnView": function() { return /* binding */ financialServicesSeparateSaleOnView; },
/* harmony export */   "financialServicesSeparateSalePaymentOnClick": function() { return /* binding */ financialServicesSeparateSalePaymentOnClick; },
/* harmony export */   "financialServicesSeparateSaleSeeMoreOnClick": function() { return /* binding */ financialServicesSeparateSaleSeeMoreOnClick; },
/* harmony export */   "financialServicesSeparateSaleTermOnClick": function() { return /* binding */ financialServicesSeparateSaleTermOnClick; },
/* harmony export */   "financialServicesSeparateSaleVideoOnClick": function() { return /* binding */ financialServicesSeparateSaleVideoOnClick; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var screenName = 'adicione-protecao';
var sellerName = 'mlseguros';
var financialServicesSeparateAddToCart = function financialServicesSeparateAddToCart(_ref) {
  var _structure$cookies, _serviceList$0$descri, _serviceList$, _Object$values, _serviceList$2;
  var services = _ref.services,
    structure = _ref.structure,
    serviceSelected = _ref.serviceSelected;
  var userId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : _structure$cookies.accountData;
  var _ref2 = (structure == null ? void 0 : structure.route) || {},
    virtualProductId = _ref2.virtualProductId;
  var product = services.product,
    serviceList = services.services;
  var category = (_serviceList$0$descri = serviceList == null ? void 0 : (_serviceList$ = serviceList[0]) == null ? void 0 : _serviceList$.description) !== null && _serviceList$0$descri !== void 0 ? _serviceList$0$descri : null;
  var _ref3 = product || {},
    productSku = _ref3.productSku,
    serviceSlug = _ref3.serviceSlug;
  var selectedOfferId = (_Object$values = Object.values(serviceSelected)) == null ? void 0 : _Object$values[0];
  var foundOffer = serviceList == null ? void 0 : (_serviceList$2 = serviceList[0]) == null ? void 0 : _serviceList$2.offers.find(function (offer) {
    return offer.id === selectedOfferId;
  });
  var _ref4 = foundOffer || {},
    description = _ref4.description,
    validity = _ref4.validity,
    price = _ref4.price;
  return {
    currency: 'BRL',
    event: 'add_to_cart',
    eventCategory: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(category),
    idusuario: (userId == null ? void 0 : userId.id) || null,
    items: [{
      item_category: "".concat(serviceSlug).concat(validity),
      item_id: virtualProductId || 'null',
      item_name: "adicao-de-servico-ao-produto:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(description)) || 0,
      item_variant: productSku || 'null',
      price: price || 'null'
    }],
    loginAtivo: userId ? 'logado' : 'nao-logado',
    screenName: "seguro-complementar:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(category)),
    value: price || 0
  };
};
var financialServicesSeparateSaleDetailsOnClick = function financialServicesSeparateSaleDetailsOnClick() {
  return {
    content_id: 'detalhes-do-seguro',
    content_type: screenName,
    event: 'select_content'
  };
};
var financialServicesSeparateSaleOnChange = function financialServicesSeparateSaleOnChange(_ref5) {
  var validity = _ref5.validity,
    selected = _ref5.selected,
    _ref5$serviceType = _ref5.serviceType,
    serviceType = _ref5$serviceType === void 0 ? 'troca-certa' : _ref5$serviceType;
  var isSelect = selected ? 'marcar' : 'desmarcar';
  return {
    content_id: "".concat(isSelect, ":").concat(serviceType, "-").concat(validity, "-meses"),
    content_type: screenName,
    event: 'select_content'
  };
};
var financialServicesSeparateSaleOnView = function financialServicesSeparateSaleOnView(_ref6) {
  var device = _ref6.device,
    partnerId = _ref6.partnerId,
    userId = _ref6.userId,
    userIsLogged = _ref6.userIsLogged,
    userLocation = _ref6.userLocation;
  return {
    barraLocalizacao: undefined,
    cepPreenchido: (userLocation == null ? void 0 : userLocation.zipCode) ? 1 : 0,
    cidadeuf: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(userLocation),
    device: "site-".concat(device),
    event: 'virtualPageview',
    existeDelivery: undefined,
    hitTimestamp: new Date().getTime(),
    idDaLoja: sellerName,
    idParceiro: partnerId,
    idUsuario: userId,
    loginAtivo: userIsLogged ? 'logado' : 'nao-logado',
    nomeDaLoja: sellerName,
    pageType: 'servico',
    screenName: screenName,
    usuarioClube: undefined
  };
};
var financialServicesSeparateSalePaymentOnClick = function financialServicesSeparateSalePaymentOnClick() {
  return {
    content_id: 'ir-para-pagamento',
    content_type: screenName,
    event: 'select_content'
  };
};
var financialServicesSeparateSaleSeeMoreOnClick = function financialServicesSeparateSaleSeeMoreOnClick() {
  return {
    content_id: 'ver-mais',
    content_type: screenName,
    event: 'select_content'
  };
};
var financialServicesSeparateSaleTermOnClick = function financialServicesSeparateSaleTermOnClick() {
  return {
    content_id: 'termos-de-autorizacao-cobranca',
    content_type: screenName,
    event: 'select_content'
  };
};
var financialServicesSeparateSaleVideoOnClick = function financialServicesSeparateSaleVideoOnClick() {
  return {
    content_id: 'ver-video',
    content_type: screenName,
    event: 'select_content'
  };
};

/***/ }),

/***/ 96134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clickEvent": function() { return /* binding */ clickEvent; },
/* harmony export */   "gateKeeperButtonClick": function() { return /* binding */ gateKeeperButtonClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var clickEvent = function clickEvent(_ref) {
  var _ref$ga = _ref.ga,
    ga = _ref$ga === void 0 ? {} : _ref$ga;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'porteiro',
    eventLabel: 'cta',
    eventNonInteraction: 0
  }, ga);
};
var gateKeeperButtonClick = function gateKeeperButtonClick(data) {
  return data && clickEvent(data);
};

/***/ }),

/***/ 8139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clickEvent": function() { return /* binding */ clickEvent; },
/* harmony export */   "hotlinkClick": function() { return /* binding */ hotlinkClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var clickEvent = function clickEvent(_ref, config) {
  var _config$structure;
  var text = _ref.text,
    _ref$ga = _ref.ga,
    ga = _ref$ga === void 0 ? {} : _ref$ga;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "".concat(config == null ? void 0 : (_config$structure = config.structure) == null ? void 0 : _config$structure.name, ":hotlinks"),
    eventLabel: text,
    eventNonInteraction: 0
  }, ga);
};
var hotlinkClick = function hotlinkClick(data, config) {
  return data && clickEvent(data, config);
};

/***/ }),

/***/ 6115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24169);
/* harmony import */ var _addtocart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78807);
/* harmony import */ var _buybox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31956);
/* harmony import */ var _buybutton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58346);
/* harmony import */ var _blogPost__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6870);
/* harmony import */ var _continueToCart__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(7779);
/* harmony import */ var _pageView__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96617);
/* harmony import */ var _pmdShareLinks__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(66298);
/* harmony import */ var _productList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84638);
/* harmony import */ var _paginate__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(64141);
/* harmony import */ var _reviewFilterClick__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(42354);
/* harmony import */ var _zipCodeBar__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(46091);
/* harmony import */ var _signin__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(84950);
/* harmony import */ var _search__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87003);
/* harmony import */ var _hotlinks__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(8139);
/* harmony import */ var _gatekeeperbutton__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(96134);
/* harmony import */ var _luContent__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(89937);
/* harmony import */ var _menu__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1772);
/* harmony import */ var _linkSuggestions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48383);
/* harmony import */ var _suggestionImpression__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81656);
/* harmony import */ var _subcategoryList__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(43444);
/* harmony import */ var _displayType__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1602);
/* harmony import */ var _filter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64056);
/* harmony import */ var _product__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63707);
/* harmony import */ var _shipping__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(90803);
/* harmony import */ var _review__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(56778);
/* harmony import */ var _blogbutton__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(73191);
/* harmony import */ var _viewItem__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(67663);
/* harmony import */ var _miniapps__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(23481);
/* harmony import */ var _questions__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(84093);
/* harmony import */ var _blogPageView__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(97100);
/* harmony import */ var _sellerDetails__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(92908);
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(42340);
/* harmony import */ var _productTags__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(1041);
/* harmony import */ var _productLabels__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(39478);
/* harmony import */ var _productBenefits__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(44541);
/* harmony import */ var _chatbotLu__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(6450);
/* harmony import */ var _sellerChat__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(48339);
/* harmony import */ var _reviewFormSubmit__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(96866);
/* harmony import */ var _promotionBanner__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(31519);
/* harmony import */ var _financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(75088);
/* harmony import */ var _buybuttonServices__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(68789);
/* harmony import */ var _didYouMean__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(71330);
/* harmony import */ var _spacePageView__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(29563);
/* harmony import */ var _chatConversationFollowSeller__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(82378);
/* harmony import */ var _cardan__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(59190);














































var events = {
  'action:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_signin__WEBPACK_IMPORTED_MODULE_21__.signInClick)],
  'addtocart:error': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_addtocart__WEBPACK_IMPORTED_MODULE_1__.addToCartError)],
  'addtocart:success': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_addtocart__WEBPACK_IMPORTED_MODULE_1__.addToCartSuccess)],
  'blogpost:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_blogPost__WEBPACK_IMPORTED_MODULE_4__.postClick)],
  'buybox:addtocart': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_buybox__WEBPACK_IMPORTED_MODULE_2__.buyBoxButtonClick)],
  'buybox:seemoreoffers': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_buybox__WEBPACK_IMPORTED_MODULE_2__.buyBoxSeeMoreOffers)],
  'buybutton-services:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_buybuttonServices__WEBPACK_IMPORTED_MODULE_22__.buybuttonServicesOnClick)],
  'buybuttons:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_buybutton__WEBPACK_IMPORTED_MODULE_3__.buyButtonClick)],
  'cardan:changeForm:model:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_cardan__WEBPACK_IMPORTED_MODULE_23__.cardanChangeFormModel)],
  'cardan:changeForm:plateNumber:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_cardan__WEBPACK_IMPORTED_MODULE_23__.cardanChangeFormPlateNumber)],
  'cardan:changeVehicle:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_cardan__WEBPACK_IMPORTED_MODULE_23__.cardanChangeVehicleClick)],
  'cardan:product:askSeller:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_cardan__WEBPACK_IMPORTED_MODULE_23__.cardanProductAskSellerClick)],
  'cardan:product:changeVehicle:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_cardan__WEBPACK_IMPORTED_MODULE_23__.cardanProductChangeVehicleClick)],
  'cardan:product:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_cardan__WEBPACK_IMPORTED_MODULE_23__.cardanProductView)],
  'cardan:search:clean:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_cardan__WEBPACK_IMPORTED_MODULE_23__.cardanCleanSearch)],
  'cardan:search:model:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_cardan__WEBPACK_IMPORTED_MODULE_23__.cardanSearchModelClick)],
  'cardan:search:plateNumber:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_cardan__WEBPACK_IMPORTED_MODULE_23__.cardanSearchPlateNumberClick)],
  'cardan:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_cardan__WEBPACK_IMPORTED_MODULE_23__.cardanView)],
  'chat-conversation:followSeller:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_chatConversationFollowSeller__WEBPACK_IMPORTED_MODULE_24__.clickFollowSellerEvent)],
  'chatbotLu:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_chatbotLu__WEBPACK_IMPORTED_MODULE_25__.chatbotLuClick)],
  'chatbotLu:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_chatbotLu__WEBPACK_IMPORTED_MODULE_25__.chatbotLuImpression)],
  'continuetocart:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_continueToCart__WEBPACK_IMPORTED_MODULE_26__["default"])],
  'delivery:filter:clear': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_12__.filterDeliveryClear)],
  'delivery:filter:selected': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_12__.filterDeliverySelect)],
  'didyoumean:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_didYouMean__WEBPACK_IMPORTED_MODULE_27__.didYouMeanSelect)],
  'didyoumean:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_didYouMean__WEBPACK_IMPORTED_MODULE_27__.didYouMeanView)],
  'financial-services-separate-sale:addToCart': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_20__.financialServicesSeparateAddToCart)],
  'financial-services-separate-sale:change': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_20__.financialServicesSeparateSaleOnChange)],
  'financial-services-separate-sale:details:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_20__.financialServicesSeparateSaleDetailsOnClick)],
  'financial-services-separate-sale:payment:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_20__.financialServicesSeparateSalePaymentOnClick)],
  'financial-services-separate-sale:seemore:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_20__.financialServicesSeparateSaleSeeMoreOnClick)],
  'financial-services-separate-sale:term:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_20__.financialServicesSeparateSaleTermOnClick)],
  'financial-services-separate-sale:video:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_20__.financialServicesSeparateSaleVideoOnClick)],
  'financial-services-separate-sale:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_20__.financialServicesSeparateSaleOnView)],
  'gatekeeper:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_gatekeeperbutton__WEBPACK_IMPORTED_MODULE_28__.gateKeeperButtonClick)],
  'hotlink:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_hotlinks__WEBPACK_IMPORTED_MODULE_29__.hotlinkClick)],
  'link-suggestions:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_linkSuggestions__WEBPACK_IMPORTED_MODULE_9__.suggestionLinkClick)],
  'link-suggestions:impression': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_suggestionImpression__WEBPACK_IMPORTED_MODULE_10__.suggestionImpression)],
  'listlink:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_12__.filterLinkListClick)],
  'lucontent:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_luContent__WEBPACK_IMPORTED_MODULE_30__.luContentClick)],
  'lucontent:socialmedia:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_luContent__WEBPACK_IMPORTED_MODULE_30__.luContentSocialMediaClick)],
  'lucontent:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_luContent__WEBPACK_IMPORTED_MODULE_30__.luContentView)],
  'menu:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_menu__WEBPACK_IMPORTED_MODULE_8__.menuClick)],
  'menu:header:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_menu__WEBPACK_IMPORTED_MODULE_8__.menuHeaderClick)],
  pageview: [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_pageView__WEBPACK_IMPORTED_MODULE_5__["default"]), (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_18__.questionPageView), (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_miniapps__WEBPACK_IMPORTED_MODULE_17__.miniAppLoad), (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_blogPageView__WEBPACK_IMPORTED_MODULE_31__.buildBlogPageView), (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_review__WEBPACK_IMPORTED_MODULE_15__.reviewPageView), (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_19__.servicesPageView)],
  pageviewspace: [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_spacePageView__WEBPACK_IMPORTED_MODULE_32__.spacePageView)],
  'paginate:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_paginate__WEBPACK_IMPORTED_MODULE_33__.paginateClick)],
  'pmd:sharelinks:add:ready:bag:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_pmdShareLinks__WEBPACK_IMPORTED_MODULE_34__.addToReadyBag)],
  'pmd:sharelinks:generate:link:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_pmdShareLinks__WEBPACK_IMPORTED_MODULE_34__.generateLink)],
  'pmd:sharelinks:share:product:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_pmdShareLinks__WEBPACK_IMPORTED_MODULE_34__.shareProduct)],
  'product:attribute:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_product__WEBPACK_IMPORTED_MODULE_13__.productAttributeClick)],
  'product:benefits:link:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productBenefits__WEBPACK_IMPORTED_MODULE_35__.productBenefitsLinkClick)],
  'product:benefits:tags:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productTags__WEBPACK_IMPORTED_MODULE_36__.productTagsClick)],
  'product:benefits:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productBenefits__WEBPACK_IMPORTED_MODULE_35__.productBenefitsView)],
  'product:details': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_viewItem__WEBPACK_IMPORTED_MODULE_16__["default"])],
  'product:label:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productLabels__WEBPACK_IMPORTED_MODULE_37__.productLabelClick)],
  'product:paymentmethod:change': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_product__WEBPACK_IMPORTED_MODULE_13__.productPaymentMethodChange)],
  'product:paymentmethod:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_product__WEBPACK_IMPORTED_MODULE_13__.productPaymentMethodClick)],
  'product:review:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_review__WEBPACK_IMPORTED_MODULE_15__.productReviewClick)],
  'product:review:submit': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_review__WEBPACK_IMPORTED_MODULE_15__.productReviewSubmit)],
  'product:reviewform:submit': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_reviewFormSubmit__WEBPACK_IMPORTED_MODULE_38__["default"])],
  'product:shipping:change': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_shipping__WEBPACK_IMPORTED_MODULE_14__.shippingImpression)],
  'product:shipping:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_shipping__WEBPACK_IMPORTED_MODULE_14__.shippingClick)],
  'product:shipping:error': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_shipping__WEBPACK_IMPORTED_MODULE_14__.shippingError)],
  'product:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productList__WEBPACK_IMPORTED_MODULE_6__.productView)],
  'productlist:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productList__WEBPACK_IMPORTED_MODULE_6__.productListClick)],
  'productlist:display:change': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_displayType__WEBPACK_IMPORTED_MODULE_11__["default"])],
  'productlist:fastFilter:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_12__.fastFilterView)],
  'productlist:filter:close': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_12__.filterClose)],
  'productlist:filter:open': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_12__.filterOpen)],
  'productlist:filter:showdetail': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_12__.filterTypeClick)],
  'productlist:showFullList': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productList__WEBPACK_IMPORTED_MODULE_6__.productListShowFullList)],
  'productlist:showmore': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productList__WEBPACK_IMPORTED_MODULE_6__.productListShowMore)],
  'productlist:start:experiment': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productList__WEBPACK_IMPORTED_MODULE_6__.startExperiment)],
  'promotion:brand:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.selectPromotionBrandBanner)],
  'promotion:brand:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.viewPromotionBrandBanner)],
  'promotion:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.selectPromotionBanner)],
  'promotion:video:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.selectPromotionBannerVideo)],
  'promotion:video:complete': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.videoCompletePromotionBanner)],
  'promotion:video:progress': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.videoProgressPromotionBanner)],
  'promotion:video:start': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.videoStartPromotionBanner)],
  'promotion:video:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.viewPromotionBannerVideo)],
  'promotion:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.viewPromotionBanner)],
  'question:form:submit': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_18__.questionClickOpenConfirm)],
  'question:miniapp:open:float:modal': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_18__.clickMiniappFloatButtonForm)],
  'question:open:float:modal': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_18__.clickFloatButtonForm)],
  'question-confirm:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_18__.questionClickConfirmQuestion)],
  'question-feedback:error': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_18__.questionFeedbackResponseError)],
  'question-form:see-more': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_18__.questionFormSeeMore)],
  'question-list:impression': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_18__.questionListImpression)],
  'review:filter:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_reviewFilterClick__WEBPACK_IMPORTED_MODULE_40__["default"])],
  'reviewlist:button:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_review__WEBPACK_IMPORTED_MODULE_15__.writeReviewClick)],
  'reviewlist:sort:change': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_review__WEBPACK_IMPORTED_MODULE_15__.reviewListSort)],
  'reviewpdp:button:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_review__WEBPACK_IMPORTED_MODULE_15__.reviewPdpClick)],
  'search:clear': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_search__WEBPACK_IMPORTED_MODULE_7__.searchClear)],
  'search:close': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_search__WEBPACK_IMPORTED_MODULE_7__.searchClose)],
  'search:submit': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_search__WEBPACK_IMPORTED_MODULE_7__.searchSubmit)],
  'sellerchat:conversation:onview': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerChat__WEBPACK_IMPORTED_MODULE_41__.conversationOnView)],
  'sellerchat:inbox:conversations:onclick': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerChat__WEBPACK_IMPORTED_MODULE_41__.inboxConversationOnClick)],
  'sellerchat:inbox:conversations:onview': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerChat__WEBPACK_IMPORTED_MODULE_41__.inboxConversationListOnView)],
  'sellerdetails:click:about:rating': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerDetails__WEBPACK_IMPORTED_MODULE_42__.sellerDetailsRatingClick)],
  'sellerdetails:impression': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerDetails__WEBPACK_IMPORTED_MODULE_42__.sellerScoreImpression)],
  'sellerdetails:offers:link:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerDetails__WEBPACK_IMPORTED_MODULE_42__.sellerDetailsOffersLinkClick)],
  'sellerdetails:open:modal:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerDetails__WEBPACK_IMPORTED_MODULE_42__.sellerDetailsClickOpenModal)],
  'sellerdetailspdp:open:modal:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerDetails__WEBPACK_IMPORTED_MODULE_42__.sellerDetailsPdpLinkClick)],
  'services:add': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_19__.addService)],
  'services:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_19__.clickService)],
  'services:know-more': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_19__.servicesKnowMore)],
  'services:legal-info': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_19__.servicesLegalInfo)],
  'services:more-details': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_19__.servicesMoreDetails)],
  'services:offer-change': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_19__.servicesOfferChange)],
  'services:refuse': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_19__.refuseService)],
  'services:video': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_19__.servicesVideo)],
  'shareblog:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_blogbutton__WEBPACK_IMPORTED_MODULE_43__.shareBlogButtonClick)],
  'subcategoryfulllist:click': (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_subcategoryList__WEBPACK_IMPORTED_MODULE_44__.subcategoryFullListClick),
  'subcategorylist:click': (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_subcategoryList__WEBPACK_IMPORTED_MODULE_44__.subcategoryListClick),
  'subcategorytop:click': (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_subcategoryList__WEBPACK_IMPORTED_MODULE_44__.subcategoryTopClick),
  'suggestion:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_search__WEBPACK_IMPORTED_MODULE_7__.suggestionClick)],
  'suggestion:topterm:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_search__WEBPACK_IMPORTED_MODULE_7__.topTermClick)],
  'variation:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productList__WEBPACK_IMPORTED_MODULE_6__.variationClick)],
  'zipcodebar:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_zipCodeBar__WEBPACK_IMPORTED_MODULE_45__.zipCodeBarClick)],
  'zipcodebar:popup:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_zipCodeBar__WEBPACK_IMPORTED_MODULE_45__.zipCodeBarTooltipClick)],
  'zipcodebar:popup:close': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_zipCodeBar__WEBPACK_IMPORTED_MODULE_45__.zipCodeBarTooltipClose)],
  'zipcodebar:popup:success': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_zipCodeBar__WEBPACK_IMPORTED_MODULE_45__.zipCodeBarTooltipView)],
  'zipcodebar:popup:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_zipCodeBar__WEBPACK_IMPORTED_MODULE_45__.zipCodeBarTooltipView)],
  'zipcodebar:response:error': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_zipCodeBar__WEBPACK_IMPORTED_MODULE_45__.zipCodeBarResponseError)],
  'zipcodebar:response:success': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_zipCodeBar__WEBPACK_IMPORTED_MODULE_45__.zipCodeBarResponseSuccess)]
};
/* harmony default export */ __webpack_exports__["default"] = (events);

/***/ }),

/***/ 48383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "suggestionLinkClick": function() { return /* binding */ suggestionLinkClick; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var suggestionLinkClick = function suggestionLinkClick(link) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'magalu-has',
    eventLabel: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(link.value).toLowerCase())
  };
};

/***/ }),

/***/ 89937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildLuContent": function() { return /* binding */ buildLuContent; },
/* harmony export */   "buildLuContentClickImpression": function() { return /* binding */ buildLuContentClickImpression; },
/* harmony export */   "buildLuContentSocialMediaClickImpression": function() { return /* binding */ buildLuContentSocialMediaClickImpression; },
/* harmony export */   "buildLuContentViewImpression": function() { return /* binding */ buildLuContentViewImpression; },
/* harmony export */   "luContentClick": function() { return /* binding */ luContentClick; },
/* harmony export */   "luContentSocialMediaClick": function() { return /* binding */ luContentSocialMediaClick; },
/* harmony export */   "luContentView": function() { return /* binding */ luContentView; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var buildLuContent = function buildLuContent(_ref) {
  var id = _ref.id,
    title = _ref.title,
    position = _ref.position;
  return {
    id: id,
    name: title,
    position: position
  };
};
var buildLuContentClickImpression = function buildLuContentClickImpression() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    pageType = _ref2.pageType,
    id = _ref2.id,
    title = _ref2.title,
    position = _ref2.position,
    _ref2$eventLabel = _ref2.eventLabel,
    eventLabel = _ref2$eventLabel === void 0 ? 'materia' : _ref2$eventLabel;
  return {
    ecommerce: {
      promoClick: {
        promotions: [{
          id: id,
          name: title,
          position: position
        }]
      }
    },
    event: 'promotionClick',
    eventAction: 'click',
    eventCategory: "".concat(pageType, ":lu-explica"),
    eventLabel: eventLabel,
    eventNonInteraction: '0'
  };
};
var buildLuContentSocialMediaClickImpression = function buildLuContentSocialMediaClickImpression() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    pageType = _ref3.pageType,
    id = _ref3.id;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "".concat(pageType, ":redes-sociais"),
    eventLabel: id,
    eventNonInteraction: '0'
  };
};
var buildLuContentViewImpression = function buildLuContentViewImpression(_ref4) {
  var _ref4$eventLabel = _ref4.eventLabel,
    eventLabel = _ref4$eventLabel === void 0 ? 'materias' : _ref4$eventLabel,
    pageType = _ref4.pageType,
    _ref4$promotions = _ref4.promotions,
    promotions = _ref4$promotions === void 0 ? [] : _ref4$promotions;
  return {
    ecommerce: {
      promoView: {
        promotions: promotions.map(function (promotion) {
          return buildLuContent(promotion);
        })
      }
    },
    event: 'promotionView',
    eventAction: 'impression',
    eventCategory: "".concat(pageType, ":lu-explica"),
    eventLabel: eventLabel,
    eventNonInteraction: 1
  };
};
var luContentClick = function luContentClick() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    structure = _ref5.structure;
  return buildLuContentClickImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, {
    pageType: structure == null ? void 0 : structure.name
  }));
};
var luContentSocialMediaClick = function luContentSocialMediaClick() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    structure = _ref6.structure;
  return buildLuContentSocialMediaClickImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, {
    pageType: structure == null ? void 0 : structure.name
  }));
};
var luContentView = function luContentView(data) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    structure = _ref7.structure;
  return buildLuContentViewImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, {
    pageType: structure == null ? void 0 : structure.name
  }));
};

/***/ }),

/***/ 1772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "menuClick": function() { return /* binding */ menuClick; },
/* harmony export */   "menuHeaderClick": function() { return /* binding */ menuHeaderClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);


var buildEvent = {
  event: 'clickEvent',
  eventAction: 'click',
  eventCategory: 'menu',
  eventNonInteraction: '0'
};
var handleContact = function handleContact(label) {
  return label === 'compre-pelo-chat' ? 'chat' : 'telefone';
};
var clickHeaderEvent = function clickHeaderEvent(structure, label) {
  var _ref = (structure == null ? void 0 : structure.cookies) || {},
    accountData = _ref.accountData;
  var accountStatus = accountData ? 'logado' : 'deslogado';
  var headerLabel = accountData ? 'meu-espaco' : 'entre-ou-cadastre-se';
  var termLabel = label ? "".concat(accountStatus, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label)) : headerLabel;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, buildEvent, {
    eventLabel: termLabel
  });
};
var clickEvent = function clickEvent(positionLabel, label) {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, buildEvent, {
    eventLabel: "".concat(positionLabel || '').concat(positionLabel === 'contato:' ? handleContact((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label)) : (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label))
  });
};
var menuClick = function menuClick(_ref2) {
  var positionLabel = _ref2.positionLabel,
    label = _ref2.label;
  return clickEvent(positionLabel, label);
};
var menuHeaderClick = function menuHeaderClick(_ref3) {
  var structure = _ref3.structure,
    label = _ref3.label;
  return clickHeaderEvent(structure, label);
};

/***/ }),

/***/ 23481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildParamsByPath": function() { return /* binding */ buildParamsByPath; },
/* harmony export */   "miniAppLoad": function() { return /* binding */ miniAppLoad; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var baseMiniAppParams = function baseMiniAppParams(userId) {
  return {
    idUsuario: userId,
    loginAtivo: userId ? 'logado' : 'nao-logado'
  };
};
var buildParamsByPath = function buildParamsByPath() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var userId = arguments.length > 1 ? arguments[1] : undefined;
  var siteId = arguments.length > 2 ? arguments[2] : undefined;
  var pathParams = {
    'product-review': {
      event: 'customScreenView',
      mini_app_name: 'avaliacao'
    },
    questions: {
      mini_app_name: 'perguntas-e-respostas',
      pageType: 'perguntas',
      screenName: 'webview:perguntas-e-respostas'
    },
    'review-list': {
      event: 'customScreenView',
      mini_app_name: 'avaliacao',
      pageType: 'avaliacao',
      screenName: 'avaliacao'
    }
  };
  var params = pathParams[id];
  if (params && siteId === 'mini-apps') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, baseMiniAppParams(userId), params);
  }
  return {};
};
var customScreenView = function customScreenView(structure) {
  var _ref = (structure == null ? void 0 : structure.cookies) || {},
    accountData = _ref.accountData;
  var userId = accountData == null ? void 0 : accountData.id;
  var customParams = buildParamsByPath(structure == null ? void 0 : structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    event: 'customScreenView'
  }, customParams);
};
var buildMiniAppLoad = function buildMiniAppLoad(eventListener) {
  return function (_ref2) {
    var _ref2$structure = _ref2.structure,
      structure = _ref2$structure === void 0 ? {} : _ref2$structure;
    var pageId = structure.id,
      siteId = structure.site;
    if (pageId === 'questions' && siteId === 'mini-apps') {
      return eventListener(structure);
    }
    return null;
  };
};
var miniAppLoad = buildMiniAppLoad(customScreenView);

/***/ }),

/***/ 96617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _utils_productFormatter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67412);
/* harmony import */ var _utils_gaEcommerceProduct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15950);
/* harmony import */ var _utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27903);





var parseEcommerce = function parseEcommerce(data) {
  return (data == null ? void 0 : data.pageType) === 'produto' && (data == null ? void 0 : data.products) ? {
    ecommerce: {
      detail: {
        products: data.products.map(function (product) {
          return (0,_utils_gaEcommerceProduct__WEBPACK_IMPORTED_MODULE_2__["default"])((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, product, {
            accountId: data.accountId,
            location: data.location,
            overview: (0,_utils_productFormatter__WEBPACK_IMPORTED_MODULE_1__["default"])(product, 'geral'),
            query: data.query,
            shippingValues: (0,_utils_productFormatter__WEBPACK_IMPORTED_MODULE_1__["default"])(product, 'frete')
          }));
        })
      }
    }
  } : {};
};
var pageView = function pageView(data) {
  var _data$products, _data$products2, _data$products3, _data$products3$, _data$products3$$ship, _data$products3$$ship2, _data$products3$$ship3, _data$products3$$ship4;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    barraLocalizacao: data.zipCodeBar ? 'verdadeiro' : 'falso',
    cepPreenchido: (data == null ? void 0 : data.zipCode) ? 'verdadeiro' : 'falso',
    cidadeuf: (data == null ? void 0 : data.location) || undefined,
    clientId: data == null ? void 0 : data.clientId,
    device: data.device,
    event: 'virtualPageview',
    existeDelivery: (data == null ? void 0 : data.valuesFilterDelivery) || undefined,
    fbc: data.fbc,
    fbp: data.fbp,
    idParceiro: (data == null ? void 0 : data.partnerId) || undefined,
    idUsuario: (data == null ? void 0 : data.accountId) || undefined,
    impressaoElemento: 1,
    loginAtivo: (data == null ? void 0 : data.accountId) ? 'logado' : 'deslogado',
    pageCategory: (data == null ? void 0 : data.categoryId) || 'nao-se-aplica',
    pageSubcategory: (data == null ? void 0 : data.subCategoryId) || 'nao-se-aplica',
    pageType: data.pageType,
    screenName: data.pageType,
    siteName: data == null ? void 0 : data.site,
    usuarioClube: undefined
  }, data.pageType === 'busca' && {
    termoBuscado: (data == null ? void 0 : data.term) || undefined
  }, (data == null ? void 0 : data.products) && {
    listaVazia: (data == null ? void 0 : (_data$products = data.products) == null ? void 0 : _data$products.length) > 0 ? 'falso' : 'verdadeiro'
  }, {
    valorFrete: data.pageType === 'produto' && (data == null ? void 0 : (_data$products2 = data.products) == null ? void 0 : _data$products2.length) > 0 ? data == null ? void 0 : (_data$products3 = data.products) == null ? void 0 : (_data$products3$ = _data$products3[0]) == null ? void 0 : (_data$products3$$ship = _data$products3$.shipping) == null ? void 0 : (_data$products3$$ship2 = _data$products3$$ship[0]) == null ? void 0 : (_data$products3$$ship3 = _data$products3$$ship2.packages) == null ? void 0 : (_data$products3$$ship4 = _data$products3$$ship3[0]) == null ? void 0 : _data$products3$$ship4.price : undefined
  }, data.storeDimensions, parseEcommerce(data));
};
var willPageViewTrigger = function willPageViewTrigger(siteName, pageType) {
  var excludedSites = ['blog'];
  var excludedPages = ['listagem-de-reviews', 'avaliar-produto', 'service-new', 'todas-marcas'];
  return !(excludedSites.includes(siteName) || excludedPages.includes(pageType));
};
var buildPageView = function buildPageView(listener) {
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      structure = _ref.structure,
      data = _ref.data;
    var _ref2 = structure || {},
      _ref2$name = _ref2.name,
      pageType = _ref2$name === void 0 ? 'busca' : _ref2$name,
      _ref2$device = _ref2.device,
      device = _ref2$device === void 0 ? 'mobile' : _ref2$device,
      components = _ref2.components,
      siteName = _ref2.site,
      query = _ref2.query;
    var _ref3 = (structure == null ? void 0 : structure.cookies) || {},
      location = _ref3.location,
      clientId = _ref3.clientId,
      accountData = _ref3.accountData,
      partnerId = _ref3.partnerId;
    var _ref4 = (structure == null ? void 0 : structure.route) || {},
      term = _ref4.term,
      slug = _ref4.slug,
      categoryId = _ref4.categoryId,
      subCategoryId = _ref4.subCategoryId;
    if (willPageViewTrigger(siteName, pageType)) {
      var _data$search, _data$search2, _data$search2$filters, _filterBySlug$values, _filterBySlug$values$;
      var products = pageType === 'produto' && data.product ? [data.product] : data == null ? void 0 : (_data$search = data.search) == null ? void 0 : _data$search.products;
      var filterBySlug = data == null ? void 0 : (_data$search2 = data.search) == null ? void 0 : (_data$search2$filters = _data$search2.filters) == null ? void 0 : _data$search2$filters.find(_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .filterByDelivery */ .wz);
      var valuesFilterDelivery = filterBySlug == null ? void 0 : (_filterBySlug$values = filterBySlug.values) == null ? void 0 : (_filterBySlug$values$ = _filterBySlug$values.map(function (item) {
        return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(item.label);
      })) == null ? void 0 : _filterBySlug$values$.join('|');
      var storeDimensions = (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_4__["default"])(data == null ? void 0 : data.channel);
      return listener({
        accountId: accountData == null ? void 0 : accountData.id,
        accountName: accountData == null ? void 0 : accountData.name,
        categoryId: categoryId,
        clientId: clientId,
        device: "site-".concat(device),
        fbc: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)('_fbc'),
        fbp: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)('_fbp'),
        location: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(location),
        pageType: pageType,
        partnerId: partnerId,
        products: products,
        query: query,
        slug: slug,
        storeDimensions: storeDimensions,
        subCategoryId: subCategoryId,
        term: term,
        valuesFilterDelivery: valuesFilterDelivery,
        zipCode: location == null ? void 0 : location.zipCode,
        zipCodeBar: components == null ? void 0 : components.find(function (_ref5) {
          var name = _ref5.name;
          return name === 'ZipCodeBar';
        })
      });
    }
    return null;
  };
};
/* harmony default export */ __webpack_exports__["default"] = (buildPageView(pageView));

/***/ }),

/***/ 64141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "paginateClick": function() { return /* binding */ paginateClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59740);
/* harmony import */ var _utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27903);


var _excluded = ["structure"];

var clickEvent = function clickEvent(_ref2, _ref) {
  var _args$data;
  var eventLabel = _ref2.eventLabel;
  var structure = _ref.structure,
    args = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref, _excluded);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "".concat(structure == null ? void 0 : structure.name, ":paginacao"),
    eventLabel: eventLabel,
    eventNonInteraction: '0'
  }, (args == null ? void 0 : (_args$data = args.data) == null ? void 0 : _args$data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_2__["default"])(args.data.channel)));
};
var paginateClick = function paginateClick() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return clickEvent(data, args);
};

/***/ }),

/***/ 66298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addToReadyBag": function() { return /* binding */ addToReadyBag; },
/* harmony export */   "generateLink": function() { return /* binding */ generateLink; },
/* harmony export */   "shareProduct": function() { return /* binding */ shareProduct; }
/* harmony export */ });
var addToReadyBag = function addToReadyBag(_ref) {
  var productId = _ref.productId,
    productName = _ref.productName;
  return {
    event: 'add_to_ready_bag',
    item_id: productId,
    item_name: productName
  };
};
var generateLink = function generateLink(_ref2) {
  var pageType = _ref2.pageType,
    productId = _ref2.productId,
    productName = _ref2.productName;
  return {
    content_type: "".concat(pageType, ":gerar-link"),
    event: 'generate_link',
    item_id: productId,
    item_name: productName
  };
};
var shareProduct = function shareProduct(_ref3) {
  var shareAction = _ref3.shareAction,
    pageType = _ref3.pageType,
    productId = _ref3.productId,
    productName = _ref3.productName,
    linkType = _ref3.linkType;
  return {
    content_id: shareAction,
    content_type: "".concat(pageType, ":compartilhar-link:").concat(linkType),
    event: 'share_product',
    item_id: productId,
    item_name: productName
  };
};

/***/ }),

/***/ 63707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildActualPaymentClick": function() { return /* binding */ buildActualPaymentClick; },
/* harmony export */   "buildPaymentMethodChange": function() { return /* binding */ buildPaymentMethodChange; },
/* harmony export */   "productAttributeClick": function() { return /* binding */ productAttributeClick; },
/* harmony export */   "productPaymentMethodChange": function() { return /* binding */ productPaymentMethodChange; },
/* harmony export */   "productPaymentMethodClick": function() { return /* binding */ productPaymentMethodClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var buildAttributeImpression = function buildAttributeImpression() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    type = _ref.type,
    value = _ref.value;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'produto:variacao',
    eventLabel: "".concat(type, ":").concat(value),
    eventNonInteraction: '0'
  };
};
var buildPaymentMethodImpression = function buildPaymentMethodImpression() {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'produto:forma-de-pagamento',
    eventNonInteraction: '0'
  };
};
var Enum = {
  luiza_ouro: 'cartao-luiza',
  visa: 'cartao-de-credito'
};
var buildActualPaymentClick = function buildActualPaymentClick(_ref2) {
  var _ref2$paymentId = _ref2.paymentId,
    paymentId = _ref2$paymentId === void 0 ? 'visa' : _ref2$paymentId;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, buildPaymentMethodImpression(), {
    eventLabel: "visualizar:".concat(Enum[paymentId] || paymentId)
  });
};
var buildPaymentMethodChange = function buildPaymentMethodChange(_ref3) {
  var paymentId = _ref3.paymentId;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, buildPaymentMethodImpression(), {
    eventLabel: "selecionar:".concat(Enum[paymentId] || paymentId)
  });
};
var productAttributeClick = function productAttributeClick(data) {
  return buildAttributeImpression(data);
};
var productPaymentMethodChange = function productPaymentMethodChange(data) {
  return buildPaymentMethodChange(data);
};
var productPaymentMethodClick = function productPaymentMethodClick(data) {
  return buildActualPaymentClick(data);
};

/***/ }),

/***/ 44541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "productBenefitsLinkClick": function() { return /* binding */ productBenefitsLinkClick; },
/* harmony export */   "productBenefitsView": function() { return /* binding */ productBenefitsView; }
/* harmony export */ });
var buildBenefitsLinkClick = function buildBenefitsLinkClick(_ref) {
  var eventLabel = _ref.eventLabel;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'produto:beneficios',
    eventLabel: eventLabel,
    eventNonInteraction: 0
  };
};
var buldBenefitsImpression = function buldBenefitsImpression(_ref2) {
  var labels = _ref2.labels,
    offerTags = _ref2.offerTags;
  var label;
  if (offerTags == null ? void 0 : offerTags.includes('magalu_indica')) {
    label = labels.join(':');
  } else {
    label = labels.slice(1).join(':');
  }
  return {
    event: 'clickEvent',
    eventAction: 'impression',
    eventCategory: 'produto:beneficios',
    eventLabel: label,
    eventNonInteraction: 0
  };
};
var productBenefitsLinkClick = function productBenefitsLinkClick() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    eventLabel = _ref3.eventLabel;
  return eventLabel && buildBenefitsLinkClick({
    eventLabel: eventLabel
  });
};
var productBenefitsView = function productBenefitsView(_ref4) {
  var labels = _ref4.labels,
    offerTags = _ref4.offerTags;
  return labels && buldBenefitsImpression({
    labels: labels,
    offerTags: offerTags
  });
};

/***/ }),

/***/ 39478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "productLabelClick": function() { return /* binding */ productLabelClick; }
/* harmony export */ });
var buildEvent = function buildEvent(_ref) {
  var label = _ref.label,
    variationId = _ref.variationId;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'produto:etiqueta',
    eventLabel: "".concat(label, ":").concat(variationId),
    eventNonInteraction: 0
  };
};
var productLabelClick = function productLabelClick() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    label = _ref2.label,
    variationId = _ref2.variationId;
  return label && variationId && buildEvent({
    label: label,
    variationId: variationId
  });
};

/***/ }),

/***/ 84638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildProductImpression": function() { return /* binding */ buildProductImpression; },
/* harmony export */   "productListClick": function() { return /* binding */ productListClick; },
/* harmony export */   "productListShowFullList": function() { return /* binding */ productListShowFullList; },
/* harmony export */   "productListShowMore": function() { return /* binding */ productListShowMore; },
/* harmony export */   "productListView": function() { return /* binding */ productListView; },
/* harmony export */   "productView": function() { return /* binding */ productView; },
/* harmony export */   "startExperiment": function() { return /* binding */ startExperiment; },
/* harmony export */   "variationClick": function() { return /* binding */ variationClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59740);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90545);


var _excluded = ["accountId", "id", "variationId", "title", "list"],
  _excluded2 = ["eventCategory", "structure"],
  _excluded3 = ["list", "filters", "listPosition", "origin", "display"],
  _excluded4 = ["product", "list", "filters", "listPosition", "origin", "display"];


var eventLabel = 'product-list';
var displayEnum = {
  gallery: 'galeria',
  list: 'lista',
  miniature: 'miniatura'
};
var buildProductImpression = function buildProductImpression() {
  var _data$brand, _data$category, _data$subcategory, _data$installment, _data$seller, _data$seller2, _data$attributes, _data$attributes2, _data$attributes2$, _data$offerTags, _data$contextSearch, _data$rating, _data$price, _data$price2, _data$parsedAttribute, _data$parsedAttribute2, _data$parsedAttribute3, _data$rating2, _data$badges, _data$badges$, _data$geoLocTags, _data$shippingTag, _data$shippingTag2, _data$shippingTag3, _data$shippingTag4, _data$shippingTag5, _data$price3, _data$price4;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var accountId = _ref.accountId,
    id = _ref.id,
    variationId = _ref.variationId,
    name = _ref.title,
    list = _ref.list,
    data = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    brand: (data == null ? void 0 : (_data$brand = data.brand) == null ? void 0 : _data$brand.label) || undefined,
    category: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .categoryToString */ .H6)(data == null ? void 0 : (_data$category = data.category) == null ? void 0 : _data$category.id, data == null ? void 0 : (_data$subcategory = data.subcategory) == null ? void 0 : _data$subcategory.id),
    dimension10: (0,_utils__WEBPACK_IMPORTED_MODULE_1__.handleOrigin)(data),
    dimension11: data == null ? void 0 : data.listPosition,
    dimension12: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .gaBoolean */ .w6)(data == null ? void 0 : data.available),
    dimension13: accountId ? (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .gaBoolean */ .w6)(data == null ? void 0 : data.isOnWishlist) : undefined,
    dimension14: 'falso',
    dimension15: data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.totalAmount,
    dimension16: data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.category,
    dimension17: data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.id,
    dimension18: (data == null ? void 0 : (_data$attributes = data.attributes) == null ? void 0 : _data$attributes.length) ? data == null ? void 0 : (_data$attributes2 = data.attributes) == null ? void 0 : (_data$attributes2$ = _data$attributes2[0]) == null ? void 0 : _data$attributes2$.value : undefined,
    dimension26: data == null ? void 0 : data.term,
    dimension41: "etiqueta:".concat((data == null ? void 0 : (_data$offerTags = data.offerTags) == null ? void 0 : _data$offerTags.includes('magalu_indica')) ? '1:magalu-indica' : '0'),
    dimension48: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .gaSelectedFilters */ .Q8)(data == null ? void 0 : data.filters),
    dimension49: data == null ? void 0 : data.orderBy,
    dimension52: (data == null ? void 0 : data.contextSearch) ? data == null ? void 0 : (_data$contextSearch = data.contextSearch) == null ? void 0 : _data$contextSearch.value : 'none',
    dimension60: displayEnum[data == null ? void 0 : data.display],
    dimension62: undefined,
    dimension65: list,
    dimension68: data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : _data$rating.score,
    dimension70: (data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.bestPrice) ? data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.price : undefined,
    dimension72: data == null ? void 0 : data.location,
    dimension74: data == null ? void 0 : (_data$parsedAttribute = data.parsedAttributes) == null ? void 0 : (_data$parsedAttribute2 = _data$parsedAttribute[0]) == null ? void 0 : (_data$parsedAttribute3 = _data$parsedAttribute2.values) == null ? void 0 : _data$parsedAttribute3.length,
    dimension76: (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getBestPriceDiscount)(data),
    dimension77: (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getDiscount)(data),
    dimension78: (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getInstallmentQuantity)(data),
    dimension79: data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : _data$rating2.count,
    dimension85: data == null ? void 0 : data.page,
    dimension86: "selo:".concat((data == null ? void 0 : (_data$badges = data.badges) == null ? void 0 : (_data$badges$ = _data$badges[0]) == null ? void 0 : _data$badges$.text) || 'sem-selo', "|tags:").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : (_data$geoLocTags = data.geoLocTags) == null ? void 0 : _data$geoLocTags.title) || 'sem-tag')
  }, (data == null ? void 0 : data.showcase) ? {
    dimension90: "".concat(data.showcase.pageId, "-").concat(data.showcase.placeId).concat(data.showcase.id ? "-".concat(data.showcase.id) : ''),
    dimension91: data.showcase.type,
    dimension92: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data.showcase.title)
  } : {}, {
    dimension112: !(0,_utils__WEBPACK_IMPORTED_MODULE_1__.isSomeParametersEmpty)(data == null ? void 0 : data.shippingTag) ? "entrega-padr\xE3o:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : (_data$shippingTag = data.shippingTag) == null ? void 0 : _data$shippingTag.time) || 'null'), ":").concat((data == null ? void 0 : (_data$shippingTag2 = data.shippingTag) == null ? void 0 : _data$shippingTag2.cost) === 0 ? 0 : (data == null ? void 0 : (_data$shippingTag3 = data.shippingTag) == null ? void 0 : _data$shippingTag3.cost) || 'null', "|retira-loja:").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : (_data$shippingTag4 = data.shippingTag) == null ? void 0 : _data$shippingTag4.complement) || 'null'), ":").concat((data == null ? void 0 : (_data$shippingTag5 = data.shippingTag) == null ? void 0 : _data$shippingTag5.source) || 'null') : undefined,
    id: variationId || id,
    list: list,
    name: name,
    position: data == null ? void 0 : data.position,
    price: (data == null ? void 0 : (_data$price3 = data.price) == null ? void 0 : _data$price3.bestPrice) || (data == null ? void 0 : (_data$price4 = data.price) == null ? void 0 : _data$price4.price) || undefined,
    quantity: '1',
    variant: variationId
  }, (data == null ? void 0 : data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (0,_utils__WEBPACK_IMPORTED_MODULE_1__.channelStoreDimensions)(data.channel)));
};
var buildProductListView = function buildProductListView(_ref3, _ref2) {
  var _ref3$products = _ref3.products,
    products = _ref3$products === void 0 ? [] : _ref3$products,
    _ref3$list = _ref3.list,
    list = _ref3$list === void 0 ? '' : _ref3$list,
    filters = _ref3.filters,
    origin = _ref3.origin,
    display = _ref3.display,
    listPosition = _ref3.listPosition,
    showcase = _ref3.showcase;
  var eventCategory = _ref2.eventCategory,
    structure = _ref2.structure,
    args = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref2, _excluded2);
  return {
    ecommerce: {
      impressions: products.map(function (product) {
        var _structure$cookies, _structure$cookies$ac, _product$price, _structure$cookies2, _gaSortFallback, _structure$route, _structure$route2, _structure$route3, _structure$route4, _structure$route5;
        return buildProductImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, product, args, {
          accountId: structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.id,
          discount: Number((product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.discount) || 0) ? "".concat(Number(product.price.discount), "%") : undefined,
          display: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(display),
          filters: filters,
          list: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(list),
          listPosition: listPosition,
          location: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(structure == null ? void 0 : (_structure$cookies2 = structure.cookies) == null ? void 0 : _structure$cookies2.location),
          orderBy: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(((_gaSortFallback = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .gaSortFallback */ .j1)({
            orientation: structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.sortOrientation,
            type: structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.sortType
          })) == null ? void 0 : _gaSortFallback.label) || '') || undefined,
          origin: origin,
          page: (structure == null ? void 0 : (_structure$route3 = structure.route) == null ? void 0 : _structure$route3.page) ? "page-".concat(structure == null ? void 0 : (_structure$route4 = structure.route) == null ? void 0 : _structure$route4.page) : 'page-1',
          showcase: showcase,
          term: structure == null ? void 0 : (_structure$route5 = structure.route) == null ? void 0 : _structure$route5.term,
          title: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(product == null ? void 0 : product.title)
        }));
      })
    },
    event: 'productListView',
    eventAction: 'impression',
    eventCategory: eventCategory,
    eventLabel: eventLabel,
    eventNonInteraction: '1'
  };
};
var buildProductListClick = function buildProductListClick(_ref4, _ref5) {
  var _structure$cookies3, _gaSortFallback2, _structure$route6, _structure$route7, _structure$route8, _structure$route9, _structure$route10;
  var eventCategory = _ref5.eventCategory,
    structure = _ref5.structure;
  var _ref4$list = _ref4.list,
    list = _ref4$list === void 0 ? '' : _ref4$list,
    filters = _ref4.filters,
    listPosition = _ref4.listPosition,
    origin = _ref4.origin,
    display = _ref4.display,
    data = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref4, _excluded3);
  return {
    ecommerce: {
      click: {
        actionField: {
          list: list || undefined
        },
        products: [buildProductImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data, {
          display: display,
          filters: filters,
          list: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(list),
          listPosition: listPosition,
          location: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(structure == null ? void 0 : (_structure$cookies3 = structure.cookies) == null ? void 0 : _structure$cookies3.location),
          orderBy: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(((_gaSortFallback2 = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .gaSortFallback */ .j1)({
            orientation: structure == null ? void 0 : (_structure$route6 = structure.route) == null ? void 0 : _structure$route6.sortOrientation,
            type: structure == null ? void 0 : (_structure$route7 = structure.route) == null ? void 0 : _structure$route7.sortType
          })) == null ? void 0 : _gaSortFallback2.label) || '') || undefined,
          origin: origin,
          page: (structure == null ? void 0 : (_structure$route8 = structure.route) == null ? void 0 : _structure$route8.page) ? "page-".concat(structure == null ? void 0 : (_structure$route9 = structure.route) == null ? void 0 : _structure$route9.page) : 'page-1',
          term: structure == null ? void 0 : (_structure$route10 = structure.route) == null ? void 0 : _structure$route10.term,
          title: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : data.title)
        }))]
      }
    },
    event: 'productListClick',
    eventAction: 'product-click',
    eventCategory: eventCategory,
    eventLabel: "product-list:".concat(data.variationId || data.id),
    eventNonInteraction: '0'
  };
};
var productListClick = function productListClick() {
  var _args$structure, _args$structure2, _args$structure3;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildProductListClick(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    eventCategory: "".concat(args == null ? void 0 : (_args$structure = args.structure) == null ? void 0 : _args$structure.name, ":").concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.getSearchTerm)(args == null ? void 0 : (_args$structure2 = args.structure) == null ? void 0 : _args$structure2.id, data, args == null ? void 0 : (_args$structure3 = args.structure) == null ? void 0 : _args$structure3.route))
  }, args));
};
var productListShowFullList = function productListShowFullList() {
  var _args$structure4;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "".concat((args == null ? void 0 : (_args$structure4 = args.structure) == null ? void 0 : _args$structure4.name) || '', ":veja-a-lista-completa"),
    eventLabel: data.eventLabel || '',
    eventNonInteraction: '0'
  };
};
var productListShowMore = function productListShowMore() {
  var _args$structure5;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "".concat((args == null ? void 0 : (_args$structure5 = args.structure) == null ? void 0 : _args$structure5.name) || '', ":mostrar-mais-produtos"),
    eventLabel: data.eventLabel || '',
    eventNonInteraction: '0'
  };
};
var productListView = function productListView() {
  var _args$structure6, _args$structure7, _args$structure8;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildProductListView(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    eventCategory: "".concat(args == null ? void 0 : (_args$structure6 = args.structure) == null ? void 0 : _args$structure6.name, ":").concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.getSearchTerm)(args == null ? void 0 : (_args$structure7 = args.structure) == null ? void 0 : _args$structure7.id, data, args == null ? void 0 : (_args$structure8 = args.structure) == null ? void 0 : _args$structure8.route))
  }, args));
};
var buildProductItem = function buildProductItem() {
  var _structure$cookies4, _gaSortFallback3, _structure$route11, _structure$route12, _structure$route13;
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    eventCategory = _ref7.eventCategory,
    structure = _ref7.structure;
  var product = _ref6.product,
    _ref6$list = _ref6.list,
    list = _ref6$list === void 0 ? '' : _ref6$list,
    filters = _ref6.filters,
    listPosition = _ref6.listPosition,
    origin = _ref6.origin,
    display = _ref6.display,
    data = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref6, _excluded4);
  return {
    ecommerce: {
      impressions: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, buildProductImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data, product, {
        display: display,
        filters: filters,
        list: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(list),
        listPosition: listPosition,
        location: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(structure == null ? void 0 : (_structure$cookies4 = structure.cookies) == null ? void 0 : _structure$cookies4.location),
        orderBy: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(((_gaSortFallback3 = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .gaSortFallback */ .j1)({
          orientation: structure == null ? void 0 : (_structure$route11 = structure.route) == null ? void 0 : _structure$route11.sortOrientation,
          type: structure == null ? void 0 : (_structure$route12 = structure.route) == null ? void 0 : _structure$route12.sortType
        })) == null ? void 0 : _gaSortFallback3.label) || '') || undefined,
        origin: origin,
        term: structure == null ? void 0 : (_structure$route13 = structure.route) == null ? void 0 : _structure$route13.term,
        title: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(product == null ? void 0 : product.title)
      })))]
    },
    event: 'productListView',
    eventAction: 'impression',
    eventCategory: eventCategory,
    eventLabel: eventLabel,
    eventNonInteraction: '1'
  };
};
var productView = function productView() {
  var _args$structure9, _args$structure10, _args$structure11;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildProductItem(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    eventCategory: "".concat(args == null ? void 0 : (_args$structure9 = args.structure) == null ? void 0 : _args$structure9.name, ":").concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.getSearchTerm)(args == null ? void 0 : (_args$structure10 = args.structure) == null ? void 0 : _args$structure10.id, data, args == null ? void 0 : (_args$structure11 = args.structure) == null ? void 0 : _args$structure11.route))
  }, args));
};
var startExperiment = function startExperiment() {
  var _args$structure12, _data$abTesting, _data$abTesting2, _data$abTesting3, _data$abTesting4;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    event: 'Search_startExperiment',
    experimentChannel: args == null ? void 0 : (_args$structure12 = args.structure) == null ? void 0 : _args$structure12.device,
    experimentID: data == null ? void 0 : (_data$abTesting = data.abTesting) == null ? void 0 : _data$abTesting.id,
    experimentName: data == null ? void 0 : (_data$abTesting2 = data.abTesting) == null ? void 0 : _data$abTesting2.name,
    experimentVariantID: data == null ? void 0 : (_data$abTesting3 = data.abTesting) == null ? void 0 : _data$abTesting3.variantId,
    experimentVariantName: data == null ? void 0 : (_data$abTesting4 = data.abTesting) == null ? void 0 : _data$abTesting4.variantName
  };
};
var variationClick = function variationClick() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "busca",
    eventLabel: "imagens-variacoes:".concat(data == null ? void 0 : data.type, ":").concat(data == null ? void 0 : data.value) || 0,
    eventNonInteraction: '0'
  };
};

/***/ }),

/***/ 1041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "productTagsClick": function() { return /* binding */ productTagsClick; }
/* harmony export */ });
var buildEvent = function buildEvent(label) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'produto:beneficios',
    eventLabel: label,
    eventNonInteraction: 0
  };
};
var productTagsClick = function productTagsClick(label) {
  return label && buildEvent(label);
};

/***/ }),

/***/ 31519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "selectPromotionBanner": function() { return /* binding */ selectPromotionBanner; },
/* harmony export */   "selectPromotionBannerVideo": function() { return /* binding */ selectPromotionBannerVideo; },
/* harmony export */   "selectPromotionBrandBanner": function() { return /* binding */ selectPromotionBrandBanner; },
/* harmony export */   "videoCompletePromotionBanner": function() { return /* binding */ videoCompletePromotionBanner; },
/* harmony export */   "videoProgressPromotionBanner": function() { return /* binding */ videoProgressPromotionBanner; },
/* harmony export */   "videoStartPromotionBanner": function() { return /* binding */ videoStartPromotionBanner; },
/* harmony export */   "viewPromotionBanner": function() { return /* binding */ viewPromotionBanner; },
/* harmony export */   "viewPromotionBannerVideo": function() { return /* binding */ viewPromotionBannerVideo; },
/* harmony export */   "viewPromotionBrandBanner": function() { return /* binding */ viewPromotionBrandBanner; }
/* harmony export */ });
var buildPromotionBanner = function buildPromotionBanner(eventType) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isVideo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    content_type: isVideo ? 'video' : data == null ? void 0 : data.contentType,
    creative_name: "".concat(data == null ? void 0 : data.page, ":magalu:").concat(isVideo ? 'video' : data == null ? void 0 : data.contentType),
    creative_slot: "".concat(data == null ? void 0 : data.position, ":").concat(data == null ? void 0 : data.slot),
    dimension4: data == null ? void 0 : data.campaignId,
    event: eventType,
    location_id: "".concat(data == null ? void 0 : data.size, ":").concat(data == null ? void 0 : data.page, ":banner").concat((data == null ? void 0 : data.contentType) === 'banner_list' ? ":".concat((data == null ? void 0 : data.index) + 1) : ''),
    motorBanner: 'topsort',
    screenName: data == null ? void 0 : data.screenName
  };
};
var buildPromotionBrandBanner = function buildPromotionBrandBanner(eventType) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    ad_type: 'sponsored_brands',
    content_type: 'sponsored_brands',
    creative_name: "".concat(data == null ? void 0 : data.page, ":magalu:sponsored_brands"),
    creative_slot: "".concat(data == null ? void 0 : data.position, ":").concat(data == null ? void 0 : data.slot),
    dimension4: data == null ? void 0 : data.campaignId,
    event: eventType,
    location_id: "".concat(data == null ? void 0 : data.page, ":magalu:").concat(data == null ? void 0 : data.vendorId),
    motorBanner: 'topsort',
    screenName: data == null ? void 0 : data.screenName
  };
};
var buildPromotionVideo = function buildPromotionVideo() {
  var _data$ad_type;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var eventType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    ad_type: (_data$ad_type = data == null ? void 0 : data.ad_type) !== null && _data$ad_type !== void 0 ? _data$ad_type : null,
    content_type: 'video',
    creative_slot: data == null ? void 0 : data.creative_slot,
    event: eventType,
    video_current_time: data == null ? void 0 : data.video_current_time,
    video_duration: data == null ? void 0 : data.video_duration,
    video_percent: data == null ? void 0 : data.video_percent,
    video_provider: 'interno',
    video_url: data == null ? void 0 : data.video_url,
    visible: 'true'
  };
};
var selectPromotionBanner = function selectPromotionBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBanner('select_promotion', data);
};
var selectPromotionBannerVideo = function selectPromotionBannerVideo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBanner('select_promotion', data, true);
};
var selectPromotionBrandBanner = function selectPromotionBrandBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBrandBanner('select_promotion', data);
};
var videoCompletePromotionBanner = function videoCompletePromotionBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionVideo(data, 'video_complete');
};
var videoProgressPromotionBanner = function videoProgressPromotionBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionVideo(data, 'video_progress');
};
var videoStartPromotionBanner = function videoStartPromotionBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionVideo(data, 'video_start');
};
var viewPromotionBanner = function viewPromotionBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBanner('view_promotion', data);
};
var viewPromotionBannerVideo = function viewPromotionBannerVideo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBanner('view_promotion', data, true);
};
var viewPromotionBrandBanner = function viewPromotionBrandBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBrandBanner('view_promotion', data);
};

/***/ }),

/***/ 84093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "baseFloatFormButtonClick": function() { return /* binding */ baseFloatFormButtonClick; },
/* harmony export */   "clickFloatButtonForm": function() { return /* binding */ clickFloatButtonForm; },
/* harmony export */   "clickMiniappFloatButtonForm": function() { return /* binding */ clickMiniappFloatButtonForm; },
/* harmony export */   "questionClickConfirmQuestion": function() { return /* binding */ questionClickConfirmQuestion; },
/* harmony export */   "questionClickOpenConfirm": function() { return /* binding */ questionClickOpenConfirm; },
/* harmony export */   "questionFeedbackResponseError": function() { return /* binding */ questionFeedbackResponseError; },
/* harmony export */   "questionFormSeeMore": function() { return /* binding */ questionFormSeeMore; },
/* harmony export */   "questionListImpression": function() { return /* binding */ questionListImpression; },
/* harmony export */   "questionPageView": function() { return /* binding */ questionPageView; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _miniapps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23481);



var eventClick = 'clickEvent';
var buildLabel = function buildLabel(_ref) {
  var _data$questions, _structure$route, _structure$route2;
  var data = _ref.data,
    structure = _ref.structure,
    userId = _ref.userId;
  var logged = userId ? 'logado' : 'nao-logado';
  var questionsLength = (data == null ? void 0 : (_data$questions = data.questions) == null ? void 0 : _data$questions.totalQuestions) || 0;
  var variationId = (structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.productId) || (structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.questionVariationId);
  return "".concat(variationId, "|").concat(logged, "|perguntas:").concat(questionsLength);
};
var eventCategory = 'produto:perguntas';
var eventNonInteraction = 1;
var baseFloatFormButtonClick = function baseFloatFormButtonClick(_ref2) {
  var _data$product;
  var data = _ref2.data,
    label = _ref2.label,
    userId = _ref2.userId,
    structure = _ref2.structure;
  var productId = (_data$product = data.product) == null ? void 0 : _data$product.id;
  var miniAppKeys = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: eventClick,
    eventAction: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label), ":").concat(productId),
    eventCategory: eventCategory,
    eventLabel: buildLabel({
      data: data,
      structure: structure,
      userId: userId
    }),
    idUsuario: userId
  }, miniAppKeys);
};
var clickFloatButtonForm = function clickFloatButtonForm(_ref3, _ref4) {
  var label = _ref3.label,
    userId = _ref3.userId;
  var data = _ref4.data,
    structure = _ref4.structure;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, baseFloatFormButtonClick({
    data: data,
    label: label,
    structure: structure,
    userId: userId
  }));
};
var clickMiniappFloatButtonForm = function clickMiniappFloatButtonForm(_ref5, _ref6) {
  var label = _ref5.label,
    userId = _ref5.userId;
  var data = _ref6.data,
    structure = _ref6.structure;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, baseFloatFormButtonClick({
    data: data,
    label: label,
    structure: structure,
    userId: userId
  }), {
    pageType: 'perguntas',
    screenName: 'webview:perguntas-e-respostas'
  });
};
var questionClickConfirmQuestion = function questionClickConfirmQuestion(_ref7, _ref8) {
  var _data$product2;
  var userId = _ref7.userId;
  var data = _ref8.data,
    structure = _ref8.structure;
  var productId = (_data$product2 = data.product) == null ? void 0 : _data$product2.id;
  var miniAppKeys = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: eventClick,
    eventAction: "confirmar:".concat(productId),
    eventCategory: eventCategory,
    eventLabel: buildLabel({
      data: data,
      structure: structure,
      userId: userId
    }),
    eventNonInteraction: 0
  }, miniAppKeys);
};
var questionClickOpenConfirm = function questionClickOpenConfirm(_ref9, _ref10) {
  var _data$product3;
  var label = _ref9.label,
    userId = _ref9.userId;
  var data = _ref10.data,
    structure = _ref10.structure;
  var productId = (_data$product3 = data.product) == null ? void 0 : _data$product3.id;
  var miniAppKeys = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: eventClick,
    eventAction: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label), ":").concat(productId),
    eventCategory: eventCategory,
    eventLabel: buildLabel({
      data: data,
      structure: structure,
      userId: userId
    }),
    eventNonInteraction: 0
  }, miniAppKeys);
};
var questionFeedbackResponseError = function questionFeedbackResponseError(_ref11, _ref12) {
  var error = _ref11.error,
    userId = _ref11.userId;
  var structure = _ref12.structure;
  var miniAppKeys = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: eventClick,
    eventAction: 'erro',
    eventCategory: eventCategory,
    eventLabel: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(error == null ? void 0 : error.message),
    eventNonInteraction: 1
  }, miniAppKeys);
};
var questionFormSeeMore = function questionFormSeeMore(_ref13, _ref14) {
  var _data$product4;
  var label = _ref13.label,
    userId = _ref13.userId;
  var data = _ref14.data,
    structure = _ref14.structure;
  var productId = data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : _data$product4.id;
  var miniAppKeys = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: eventClick,
    eventAction: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label), ":").concat(productId),
    eventCategory: eventCategory,
    eventLabel: buildLabel({
      data: data,
      structure: structure,
      userId: userId
    }),
    eventNonInteraction: 0
  }, miniAppKeys);
};
var questionListImpression = function questionListImpression(_ref15, _ref16) {
  var _data$product5;
  var userId = _ref15.userId;
  var data = _ref16.data,
    structure = _ref16.structure;
  var productId = (_data$product5 = data.product) == null ? void 0 : _data$product5.id;
  var miniAppKeys = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: eventClick,
    eventAction: "impressao:".concat(productId),
    eventCategory: eventCategory,
    eventLabel: buildLabel({
      data: data,
      structure: structure,
      userId: userId
    }),
    eventNonInteraction: eventNonInteraction
  }, miniAppKeys);
};
var viewItem = function viewItem(data, structure) {
  var _data$product6, _structure$cookies, _structure$cookies$ac;
  var productId = (_data$product6 = data.product) == null ? void 0 : _data$product6.id;
  var userId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.id;
  var miniAppKeys = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: eventClick,
    eventAction: "view_item:".concat(productId),
    eventCategory: eventCategory,
    eventLabel: buildLabel({
      data: data,
      structure: structure,
      userId: userId
    }),
    eventNonInteraction: eventNonInteraction
  }, miniAppKeys);
};
var buildQuestionPageView = function buildQuestionPageView(eventListener) {
  return function (_ref17) {
    var data = _ref17.data,
      structure = _ref17.structure;
    var pageId = structure.id;
    if (pageId === 'questions') {
      return eventListener(data, structure);
    }
    return null;
  };
};
var questionPageView = buildQuestionPageView(viewItem);

/***/ }),

/***/ 56778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "productReviewClick": function() { return /* binding */ productReviewClick; },
/* harmony export */   "productReviewSubmit": function() { return /* binding */ productReviewSubmit; },
/* harmony export */   "reviewListSort": function() { return /* binding */ reviewListSort; },
/* harmony export */   "reviewPageView": function() { return /* binding */ reviewPageView; },
/* harmony export */   "reviewPdpClick": function() { return /* binding */ reviewPdpClick; },
/* harmony export */   "writeReviewClick": function() { return /* binding */ writeReviewClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _miniapps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23481);



var buildReviewPageView = function buildReviewPageView(_ref) {
  var structure = _ref.structure;
  var _ref2 = structure || {},
    components = _ref2.components,
    cookies = _ref2.cookies,
    id = _ref2.id,
    pageType = _ref2.name,
    route = _ref2.route,
    site = _ref2.site;
  var _ref3 = cookies || {},
    accountData = _ref3.accountData,
    customerId = _ref3.customerId;
  var allowedPageTypes = ['listagem-de-reviews', 'avaliar-produto'];
  var isReview = allowedPageTypes.includes(pageType);
  if (isReview) {
    var _cookies$location;
    var miniAppParams = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(id, accountData == null ? void 0 : accountData.id, site);
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      barraLocalizacao: Number(!!(components == null ? void 0 : components.some(function (_ref4) {
        var name = _ref4.name;
        return name === 'ZipCodeBar';
      }))),
      cepPreenchido: Number(!!(cookies == null ? void 0 : (_cookies$location = cookies.location) == null ? void 0 : _cookies$location.zipCode)),
      cidadeuf: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(cookies == null ? void 0 : cookies.location),
      device: "site-".concat((structure == null ? void 0 : structure.device) || 'mobile'),
      event: 'virtualPageview',
      existeDelivery: 'falso',
      experimentId: undefined,
      idUsuario: customerId,
      loginAtivo: (accountData == null ? void 0 : accountData.id) ? 'logado' : 'deslogado',
      mundos: null,
      pageType: "".concat(pageType),
      permitirRastreio: undefined,
      screenName: "".concat(pageType),
      sku: route == null ? void 0 : route.productId,
      usuarioClube: null
    }, miniAppParams);
  }
  return null;
};
var buildReviewImpression = function buildReviewImpression() {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'produto:avaliacao',
    eventLabel: 'avaliacoes:avaliar',
    eventNonInteraction: '0'
  };
};
var statusType = {
  ERROR_DUPLICATE_SUBMISSION: 'erro',
  INVALID_PAYLOAD: 'erro',
  OK: 'sucesso'
};
var productReviewClick = function productReviewClick() {
  return buildReviewImpression();
};
var productReviewSubmit = function productReviewSubmit(_ref5) {
  var status = _ref5.status,
    errorMessage = _ref5.errorMessage;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, buildReviewImpression(), {
    eventAction: (statusType == null ? void 0 : statusType[status]) || 'erro',
    eventLabel: errorMessage || 'sucesso'
  });
};
var buildReviewListImpression = function buildReviewListImpression(miniAppName) {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, buildReviewImpression(), {
    eventCategory: 'avaliacao:geral',
    mini_app_name: miniAppName
  });
};
var reviewListSort = function reviewListSort() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    miniAppName = _ref6.miniAppName,
    filterLabel = _ref6.filterLabel,
    sku = _ref6.sku;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, buildReviewListImpression(miniAppName), {
    eventLabel: "".concat(filterLabel, ":").concat(sku)
  });
};
var reviewPageView = function reviewPageView(args) {
  return buildReviewPageView(args || {});
};
var reviewPdpClick = function reviewPdpClick() {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, buildReviewImpression(), {
    eventCategory: 'produto:avaliacao',
    eventLabel: 'ver-todas-as-avaliacoes'
  });
};
var writeReviewClick = function writeReviewClick() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    miniAppName = _ref7.miniAppName,
    buttonLabel = _ref7.buttonLabel,
    sku = _ref7.sku;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, buildReviewListImpression(miniAppName), {
    eventLabel: "".concat(buttonLabel, ":").concat(sku)
  });
};

/***/ }),

/***/ 42354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var reviewFilterClick = function reviewFilterClick(type, _ref) {
  var data = _ref.data,
    structure = _ref.structure;
  if (structure.config.isMiniApp) {
    return {
      event: 'clickEvent',
      eventAction: 'click',
      eventCategory: 'avaliacao:geral',
      eventLabel: "".concat(type, ":").concat(data.product.variationId),
      mini_app_name: 'avaliacao'
    };
  }
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'avaliacao:geral',
    eventLabel: "".concat(type, ":").concat(data.product.variationId)
  };
};
/* harmony default export */ __webpack_exports__["default"] = (reviewFilterClick);

/***/ }),

/***/ 96866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var reviewFormSubmit = function reviewFormSubmit(comment, rating, _ref) {
  var _structure$config;
  var structure = _ref.structure;
  var eventFormSubmit = {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'avaliar-produto',
    eventLabel: "finalizar-avaliacao:".concat(rating, ":").concat((comment == null ? void 0 : comment.length) ? 1 : 0),
    eventNonInteraction: '0',
    screenName: 'avaliar-produto'
  };
  if (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.isMiniApp) {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, eventFormSubmit, {
      mini_app_name: 'avaliacao'
    });
  }
  return eventFormSubmit;
};
/* harmony default export */ __webpack_exports__["default"] = (reviewFormSubmit);

/***/ }),

/***/ 87003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildSearch": function() { return /* binding */ buildSearch; },
/* harmony export */   "searchClear": function() { return /* binding */ searchClear; },
/* harmony export */   "searchClose": function() { return /* binding */ searchClose; },
/* harmony export */   "searchSubmit": function() { return /* binding */ searchSubmit; },
/* harmony export */   "suggestionClick": function() { return /* binding */ suggestionClick; },
/* harmony export */   "topTermClick": function() { return /* binding */ topTermClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59740);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27903);


var _excluded = ["eventAction", "eventLabel", "channelDimensions"];


var clickEvent = function clickEvent(data, _ref) {
  var _args$data;
  var eventAction = _ref.eventAction,
    eventLabel = _ref.eventLabel,
    channelDimensions = _ref.channelDimensions,
    args = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    cidadeuf: (data == null ? void 0 : data.location) || undefined,
    contextoDaBusca: (data == null ? void 0 : data.origin) || undefined,
    event: 'clickEvent',
    eventAction: eventAction,
    eventCategory: 'busca:autocomplete',
    eventLabel: eventLabel || (data == null ? void 0 : data.position) || undefined,
    eventNonInteraction: '0',
    termoBuscado: (data == null ? void 0 : data.searchValue) || undefined,
    termoDigitado: (data == null ? void 0 : data.term) || undefined
  }, (args == null ? void 0 : (_args$data = args.data) == null ? void 0 : _args$data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_3__["default"])(args.data.channel)));
};
var buildSearch = function buildSearch(listener) {
  return function () {
    var _args$structure, _args$structure$cooki, _args$structure2, _args$structure2$rout;
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      origin = _ref2.origin,
      _ref2$term = _ref2.term,
      term = _ref2$term === void 0 ? '' : _ref2$term,
      position = _ref2.position;
    var args = arguments.length > 1 ? arguments[1] : undefined;
    return listener({
      location: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(args == null ? void 0 : (_args$structure = args.structure) == null ? void 0 : (_args$structure$cooki = _args$structure.cookies) == null ? void 0 : _args$structure$cooki.location),
      origin: origin,
      position: position,
      searchValue: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)(term),
      term: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)(args == null ? void 0 : (_args$structure2 = args.structure) == null ? void 0 : (_args$structure2$rout = _args$structure2.route) == null ? void 0 : _args$structure2$rout.term)
    }, args);
  };
};
var onClear = function onClear(data, args) {
  return clickEvent(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    eventAction: 'click',
    eventLabel: 'limpar'
  }, args));
};
var searchClear = buildSearch(onClear);
var onClose = function onClose(data, args) {
  return clickEvent(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    eventAction: 'click',
    eventLabel: 'fechar'
  }, args));
};
var searchClose = buildSearch(onClose);
var onSearch = function onSearch(data, args) {
  return clickEvent(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    eventAction: 'pesquisar',
    eventLabel: 'termo'
  }, args));
};
var searchSubmit = buildSearch(onSearch);
var onClick = function onClick(data, args) {
  return clickEvent(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    eventAction: 'click'
  }, args));
};
var suggestionClick = buildSearch(onClick);
var onClickTop = function onClickTop(data, args) {
  return clickEvent(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    eventAction: 'click',
    eventLabel: data.searchValue ? "top:".concat(data == null ? void 0 : data.searchValue) : undefined
  }, args));
};
var topTermClick = buildSearch(onClickTop);

/***/ }),

/***/ 48339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "conversationOnView": function() { return /* binding */ conversationOnView; },
/* harmony export */   "inboxConversationListOnView": function() { return /* binding */ inboxConversationListOnView; },
/* harmony export */   "inboxConversationOnClick": function() { return /* binding */ inboxConversationOnClick; },
/* harmony export */   "locationToString": function() { return /* binding */ locationToString; }
/* harmony export */ });
var conversationOnView = function conversationOnView(_ref) {
  var userId = _ref.userId,
    userIsLogged = _ref.userIsLogged,
    userLocation = _ref.userLocation,
    sellerName = _ref.sellerName;
  return {
    cepPreenchido: (userLocation == null ? void 0 : userLocation.zipCode) ? 1 : 0,
    cidadeuf: locationToString(userLocation),
    event: 'virtualPageview',
    idUsuario: userId,
    loginAtivo: userIsLogged ? 'logado' : 'nao-logado',
    mini_app_name: 'fale-lojista',
    pageType: 'chat',
    screenName: 'chat-lojista',
    seller: "seller:".concat(sellerName)
  };
};
var inboxConversationListOnView = function inboxConversationListOnView(_ref2) {
  var userId = _ref2.userId,
    userIsLogged = _ref2.userIsLogged,
    userLocation = _ref2.userLocation;
  return {
    cepPreenchido: userLocation.zipCode ? 1 : 0,
    cidadeuf: locationToString(userLocation),
    event: 'virtualPageview',
    idUsuario: userId,
    loginAtivo: userIsLogged ? 'logado' : 'nao-logado',
    mini_app_name: 'fale-lojista',
    pageType: 'historico-chat',
    screenName: 'historico-chat'
  };
};
var inboxConversationOnClick = function inboxConversationOnClick(_ref3) {
  var userId = _ref3.userId,
    sellerId = _ref3.sellerId;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "chat-lojista",
    eventLabel: "chat:".concat(sellerId),
    idUsuario: userId,
    mini_app_name: 'fale-lojista'
  };
};
var locationToString = function locationToString(location) {
  if (!location || (location == null ? void 0 : location.locationError) || !(location == null ? void 0 : location.zipCodeCity) || !(location == null ? void 0 : location.zipCodeState)) {
    return undefined;
  }
  return "".concat(location.zipCodeCity, ":").concat(location.zipCodeState);
};

/***/ }),

/***/ 92908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sellerDetailsClickOpenModal": function() { return /* binding */ sellerDetailsClickOpenModal; },
/* harmony export */   "sellerDetailsOffersLinkClick": function() { return /* binding */ sellerDetailsOffersLinkClick; },
/* harmony export */   "sellerDetailsPdpLinkClick": function() { return /* binding */ sellerDetailsPdpLinkClick; },
/* harmony export */   "sellerDetailsRatingClick": function() { return /* binding */ sellerDetailsRatingClick; },
/* harmony export */   "sellerScoreImpression": function() { return /* binding */ sellerScoreImpression; }
/* harmony export */ });
var buildEvent = function buildEvent() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$event = _ref.event,
    event = _ref$event === void 0 ? 'clickEvent' : _ref$event,
    _ref$eventAction = _ref.eventAction,
    eventAction = _ref$eventAction === void 0 ? 'click' : _ref$eventAction,
    eventCategory = _ref.eventCategory,
    eventLabel = _ref.eventLabel,
    _ref$eventNonInteract = _ref.eventNonInteraction,
    eventNonInteraction = _ref$eventNonInteract === void 0 ? 0 : _ref$eventNonInteract;
  return {
    event: event,
    eventAction: eventAction,
    eventCategory: eventCategory,
    eventLabel: eventLabel,
    eventNonInteraction: eventNonInteraction
  };
};
var sellerDetailsClickOpenModal = function sellerDetailsClickOpenModal() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    seller = _ref2.seller,
    variationId = _ref2.variationId;
  return variationId && (seller == null ? void 0 : seller.id) && buildEvent({
    eventCategory: "produto:geral",
    eventLabel: "ver-mais-produtos-da-loja-parceira:".concat(variationId, ":").concat(seller == null ? void 0 : seller.id)
  });
};
var sellerDetailsOffersLinkClick = function sellerDetailsOffersLinkClick(_ref3) {
  var seller = _ref3.seller;
  return buildEvent({
    eventCategory: "produto:lojista:".concat(seller == null ? void 0 : seller.id),
    eventLabel: 'ver-mais-produtos-da-loja'
  });
};
var sellerDetailsPdpLinkClick = function sellerDetailsPdpLinkClick(_ref4) {
  var seller = _ref4.seller;
  return buildEvent({
    eventCategory: "produto:".concat(seller == null ? void 0 : seller.id),
    eventLabel: 'ver-mais-sobre-a-loja'
  });
};
var sellerDetailsRatingClick = function sellerDetailsRatingClick(_ref5) {
  var seller = _ref5.seller;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "produto:".concat(seller == null ? void 0 : seller.id),
    eventLabel: 'saiba-como-foi-calculada-essa-nota',
    eventNonInteraction: 0
  };
};
var sellerScoreImpression = function sellerScoreImpression(_ref6) {
  var seller = _ref6.seller;
  var _seller$details = seller.details,
    details = _seller$details === void 0 ? {} : _seller$details;
  var deliveryRate = (details == null ? void 0 : details.deliveryRate) || {};
  var answerRate = (details == null ? void 0 : details.answerRate) || {};
  var score = null;
  var totalSales = '';
  var deliveryRateStatus = '';
  var answerRateStatus = '';
  if (details == null ? void 0 : details.score) {
    score = details.score;
    totalSales = (details == null ? void 0 : details.totalSales) ? ":".concat(details.totalSales) : '';
    deliveryRateStatus = (deliveryRate == null ? void 0 : deliveryRate.status) ? ":".concat(deliveryRate.status) : '';
    answerRateStatus = (answerRate == null ? void 0 : answerRate.status) ? ":".concat(answerRate.status) : '';
  }
  return {
    event: 'clickEvent',
    eventAction: 'impression',
    eventCategory: "produto:".concat((seller == null ? void 0 : seller.id) || null),
    eventLabel: "score:".concat(score).concat(totalSales).concat(deliveryRateStatus).concat(answerRateStatus),
    eventNonInteraction: 1
  };
};

/***/ }),

/***/ 42340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addService": function() { return /* binding */ addService; },
/* harmony export */   "clickService": function() { return /* binding */ clickService; },
/* harmony export */   "refuseService": function() { return /* binding */ refuseService; },
/* harmony export */   "servicesKnowMore": function() { return /* binding */ servicesKnowMore; },
/* harmony export */   "servicesLegalInfo": function() { return /* binding */ servicesLegalInfo; },
/* harmony export */   "servicesMoreDetails": function() { return /* binding */ servicesMoreDetails; },
/* harmony export */   "servicesOfferChange": function() { return /* binding */ servicesOfferChange; },
/* harmony export */   "servicesPageView": function() { return /* binding */ servicesPageView; },
/* harmony export */   "servicesVideo": function() { return /* binding */ servicesVideo; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var eventCategory = 'servicos';
var screenName = 'servicos';
var addService = function addService(args) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: "incluir-protecao:".concat(args == null ? void 0 : args.offers),
    eventNonInteraction: 0,
    screenName: screenName
  };
};
var clickService = function clickService(args) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: args == null ? void 0 : args.eventLabel,
    eventNonInteraction: 0,
    screenName: screenName
  };
};
var refuseService = function refuseService() {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: 'agora-nao',
    eventNonInteraction: 0,
    screenName: screenName
  };
};
var servicesKnowMore = function servicesKnowMore(args) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: "saiba-mais-servico:".concat(args == null ? void 0 : args.service),
    eventNonInteraction: 0,
    screenName: screenName
  };
};
var servicesLegalInfo = function servicesLegalInfo(args) {
  return {
    content_type: eventCategory,
    event: 'select_content',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: "saiba-mais-informacoes-garantia:".concat(args == null ? void 0 : args.service),
    eventNonInteraction: 0,
    item_id: "saiba-mais-informacoes-garantia:".concat(args == null ? void 0 : args.service),
    screenName: screenName
  };
};
var servicesMoreDetails = function servicesMoreDetails(args) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: "mais-detalhes-do-seguro:".concat(args == null ? void 0 : args.service),
    eventNonInteraction: 0,
    screenName: screenName
  };
};
var servicesOfferChange = function servicesOfferChange(args) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: "".concat((args == null ? void 0 : args.higher) ? 'aumentar-protecao' : 'diminuir-protecao', ":").concat(args == null ? void 0 : args.service),
    eventNonInteraction: 0,
    screenName: screenName
  };
};
var viewItem = function viewItem(data) {
  var _data$product, _data$product$seller, _data$product2, _data$product2$seller;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    barraLocalizacao: (data == null ? void 0 : data.zipCodeBar) ? 'verdadeiro' : 'falso',
    cepPreenchido: (data == null ? void 0 : data.zipCode) ? 1 : 0,
    cidadeuf: (data == null ? void 0 : data.location) ? "cep:".concat(data == null ? void 0 : data.zipCode, ":").concat(data == null ? void 0 : data.location) : undefined,
    clientId: data == null ? void 0 : data.clientId,
    device: data == null ? void 0 : data.device,
    event: 'virtualPageview',
    existeDelivery: (data == null ? void 0 : data.valuesFilterDelivery) || undefined,
    experimentId: undefined,
    idDaloja: data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$seller = _data$product.seller) == null ? void 0 : _data$product$seller.deliveryId,
    idParceiro: (data == null ? void 0 : data.partnerId) || undefined,
    idUsuario: (data == null ? void 0 : data.accountId) || undefined,
    impressaoElemento: 1,
    loginAtivo: (data == null ? void 0 : data.accountId) ? 'logado' : 'nao-logado',
    mundos: 'magalu',
    nomeDaLoja: data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : (_data$product2$seller = _data$product2.seller) == null ? void 0 : _data$product2$seller.deliveryDescription,
    pageCategory: (data == null ? void 0 : data.categoryId) || 'nao-se-aplica',
    pageSubcategory: (data == null ? void 0 : data.subCategoryId) || 'nao-se-aplica',
    pageType: 'servicos',
    screenName: screenName,
    siteName: data == null ? void 0 : data.site,
    usuarioClube: undefined
  }, data == null ? void 0 : data.storeDimensions);
};
var buildServicesPageView = function buildServicesPageView(eventListener) {
  return function (props) {
    var data = props.data,
      structure = props.structure;
    var pageId = structure.id;
    if (pageId === 'service-new') {
      return eventListener(data, structure);
    }
    return null;
  };
};
var servicesPageView = buildServicesPageView(viewItem);
var servicesVideo = function servicesVideo(args) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: "video-lu-explica:".concat(args == null ? void 0 : args.service),
    eventNonInteraction: 0,
    screenName: screenName
  };
};

/***/ }),

/***/ 90803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "shippingClick": function() { return /* binding */ shippingClick; },
/* harmony export */   "shippingError": function() { return /* binding */ shippingError; },
/* harmony export */   "shippingImpression": function() { return /* binding */ shippingImpression; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);


var eventCategory = 'produto:frete';
var buildShippingCalculateItemId = function buildShippingCalculateItemId(data) {
  var _deliveries$, _deliveries$2, _structure$route;
  var deliveries = data.deliveries,
    structure = data.structure;
  var isShippingAvailable = (deliveries == null ? void 0 : (_deliveries$ = deliveries[0]) == null ? void 0 : _deliveries$.status.code) || 'unavailable';
  var deliveryModalities = Array.from(new Set(deliveries == null ? void 0 : (_deliveries$2 = deliveries[0]) == null ? void 0 : _deliveries$2.modalities.map(function (_ref) {
    var type = _ref.type;
    return type;
  }))).join(':');
  return "".concat(structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.productId, ":").concat(isShippingAvailable).concat(deliveryModalities.length ? ":".concat(deliveryModalities) : '');
};
var buildShippingClick = function buildShippingClick(data) {
  var _data$deliveries, _data$deliveries$;
  return {
    action: 'click',
    cep: data.zipcode,
    content_type: eventCategory,
    deliveriesId: (_data$deliveries = data.deliveries) == null ? void 0 : (_data$deliveries$ = _data$deliveries[0]) == null ? void 0 : _data$deliveries$.id,
    event: 'shipping',
    item_id: buildShippingCalculateItemId(data)
  };
};
var buildShippingError = function buildShippingError(data) {
  var _data$structure, _data$structure$route;
  return {
    event: 'clickEvent',
    eventAction: 'erro',
    eventCategory: eventCategory,
    eventLabel: "consulta-prazo:".concat((_data$structure = data.structure) == null ? void 0 : (_data$structure$route = _data$structure.route) == null ? void 0 : _data$structure$route.productId, ":erro:").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data.error)),
    eventNonInteraction: '1'
  };
};
var buildShippingImpression = function buildShippingImpression(data) {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, buildShippingClick(data), {
    action: 'impression'
  });
};
var shippingClick = function shippingClick(data, args) {
  return buildShippingClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data, args));
};
var shippingError = function shippingError(data, args) {
  return buildShippingError((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data, args));
};
var shippingImpression = function shippingImpression(data, args) {
  return buildShippingImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data, args));
};

/***/ }),

/***/ 84950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildClickImpression": function() { return /* binding */ buildClickImpression; },
/* harmony export */   "signInClick": function() { return /* binding */ signInClick; }
/* harmony export */ });
var buildClickImpression = function buildClickImpression() {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'home:login',
    eventLabel: 'entrar',
    eventNonInteraction: 0
  };
};
var signInClick = function signInClick(action, config) {
  var _config$structure;
  if ((action == null ? void 0 : action.type) === 'login' && (config == null ? void 0 : (_config$structure = config.structure) == null ? void 0 : _config$structure.name) === 'home') {
    return buildClickImpression();
  }
  return {};
};

/***/ }),

/***/ 29563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "spacePageView": function() { return /* binding */ spacePageView; }
/* harmony export */ });
var spacePageView = function spacePageView(data) {
  return {
    barraLocalizacao: data.zipCodeBar ? 'verdadeiro' : 'falso',
    cepPreenchido: data.zipCode ? 'verdadeiro' : 'falso',
    cidadeuf: (data == null ? void 0 : data.location) || undefined,
    event: 'virtualPageview',
    idUsuario: (data == null ? void 0 : data.accountId) || undefined,
    loginAtivo: (data == null ? void 0 : data.accountId) ? 'logado' : 'deslogado',
    pageCategory: (data == null ? void 0 : data.categoryId) || 'nao-se-aplica',
    pageSubcategory: (data == null ? void 0 : data.subCategoryId) || 'nao-se-aplica',
    pageType: 'seu-espaco',
    screenName: 'seu-espaco'
  };
};

/***/ }),

/***/ 43444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildSubcategoryFullListClick": function() { return /* binding */ buildSubcategoryFullListClick; },
/* harmony export */   "buildSubcategoryListClick": function() { return /* binding */ buildSubcategoryListClick; },
/* harmony export */   "buildSubcategoryTopClick": function() { return /* binding */ buildSubcategoryTopClick; },
/* harmony export */   "subcategoryFullListClick": function() { return /* binding */ subcategoryFullListClick; },
/* harmony export */   "subcategoryListClick": function() { return /* binding */ subcategoryListClick; },
/* harmony export */   "subcategoryTopClick": function() { return /* binding */ subcategoryTopClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var buildClick = function buildClick() {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'categoria:subcategoria',
    eventNonInteraction: '0'
  };
};
var buildSubcategoryFullListClick = function buildSubcategoryFullListClick() {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, buildClick(), {
    eventLabel: 'veja-a-lista-completa'
  });
};
var buildSubcategoryListClick = function buildSubcategoryListClick(_ref) {
  var _ref$eventLabel = _ref.eventLabel,
    eventLabel = _ref$eventLabel === void 0 ? '' : _ref$eventLabel;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, buildClick(), {
    eventLabel: "todas".concat(eventLabel ? ":".concat(eventLabel) : '')
  });
};
var buildSubcategoryTopClick = function buildSubcategoryTopClick(_ref2) {
  var _ref2$eventLabel = _ref2.eventLabel,
    eventLabel = _ref2$eventLabel === void 0 ? '' : _ref2$eventLabel;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, buildClick(), {
    eventLabel: "principais".concat(eventLabel ? ":".concat(eventLabel) : '')
  });
};
var subcategoryFullListClick = function subcategoryFullListClick() {
  return buildSubcategoryFullListClick();
};
var subcategoryListClick = function subcategoryListClick(data) {
  return buildSubcategoryListClick(data);
};
var subcategoryTopClick = function subcategoryTopClick(data) {
  return buildSubcategoryTopClick(data);
};

/***/ }),

/***/ 81656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildEvent": function() { return /* binding */ buildEvent; },
/* harmony export */   "suggestionImpression": function() { return /* binding */ suggestionImpression; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var buildEvent = function buildEvent() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$event = _ref.event,
    event = _ref$event === void 0 ? 'clickEvent' : _ref$event,
    _ref$eventAction = _ref.eventAction,
    eventAction = _ref$eventAction === void 0 ? 'impression' : _ref$eventAction,
    _ref$eventCategory = _ref.eventCategory,
    eventCategory = _ref$eventCategory === void 0 ? 'magalu-has' : _ref$eventCategory,
    eventLabel = _ref.eventLabel;
  return {
    event: event,
    eventAction: eventAction,
    eventCategory: eventCategory,
    eventLabel: eventLabel
  };
};
var suggestionImpression = function suggestionImpression(data) {
  var label = data.linksSuggestions.links.map(function (item, index) {
    var pipe = item.length === index ? '' : "|";
    return "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(item.value)).concat(pipe);
  });
  var formattedLabel = label.toString().replace(/\,/g, '').replace(/\s/g, '-').replace(/\W$/, '');
  return buildEvent({
    eventLabel: "".concat(formattedLabel.toLowerCase())
  });
};

/***/ }),

/***/ 67663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
/* harmony import */ var _utils_ga4ParseDimensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53004);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59075);



var parseEcommerce = function parseEcommerce(data) {
  return {
    ecommerce: {
      detail: {
        products: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
          brand: data.brand.label,
          category: "".concat(data.category.id, "/").concat(data.subcategory.id),
          id: data.variationId,
          name: data.title.replace(/\s/g, '-'),
          price: data.price.price,
          quantity: '1',
          variant: data.variationId
        }, (0,_utils_ga4ParseDimensions__WEBPACK_IMPORTED_MODULE_0__.ga4ParseDimensions)(data))]
      }
    }
  };
};
var viewItem = function viewItem(_ref) {
  var product = _ref.product,
    shippingError = _ref.shippingError,
    structure = _ref.structure;
  var pageName = structure.name,
    _structure$cookies = structure.cookies,
    _structure$cookies2 = _structure$cookies === void 0 ? {} : _structure$cookies,
    togglePdpSellerScore = _structure$cookies2.togglePdpSellerScore,
    query = structure.query;
  var ecommerceData = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, product, {
    query: query,
    shippingError: shippingError
  });
  if (pageName === 'product' || product) {
    ecommerceData.togglePdpSellerScore = togglePdpSellerScore;
  } else {
    return null;
  }
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    currency: _constants__WEBPACK_IMPORTED_MODULE_1__.CURRENCY,
    event: 'detail',
    eventAction: 'page-load',
    eventCategory: 'produto:geral',
    eventLabel: 'view_detail',
    screenName: 'produto',
    value: product.price.fullPrice
  }, parseEcommerce(ecommerceData));
};
/* harmony default export */ __webpack_exports__["default"] = (viewItem);

/***/ }),

/***/ 46091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eventCategory": function() { return /* binding */ eventCategory; },
/* harmony export */   "zipCodeBarClick": function() { return /* binding */ zipCodeBarClick; },
/* harmony export */   "zipCodeBarResponseError": function() { return /* binding */ zipCodeBarResponseError; },
/* harmony export */   "zipCodeBarResponseSuccess": function() { return /* binding */ zipCodeBarResponseSuccess; },
/* harmony export */   "zipCodeBarTooltipClick": function() { return /* binding */ zipCodeBarTooltipClick; },
/* harmony export */   "zipCodeBarTooltipClose": function() { return /* binding */ zipCodeBarTooltipClose; },
/* harmony export */   "zipCodeBarTooltipSuccessView": function() { return /* binding */ zipCodeBarTooltipSuccessView; },
/* harmony export */   "zipCodeBarTooltipView": function() { return /* binding */ zipCodeBarTooltipView; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);
/* harmony import */ var _utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27903);


var eventCategory = "barra-localizacao";
var buildPopupZipCodeBarImpression = function buildPopupZipCodeBarImpression(_ref) {
  var data = _ref.data,
    eventLabel = _ref.eventLabel;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    event: 'tooltipView',
    eventAction: 'impression',
    eventCategory: eventCategory,
    eventLabel: eventLabel,
    eventNonInteraction: '1'
  }, (data == null ? void 0 : data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_1__["default"])(data.channel)));
};
var buildPopupZipCodeBarClick = function buildPopupZipCodeBarClick(_ref2) {
  var data = _ref2.data,
    eventLabel = _ref2.eventLabel;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: eventLabel,
    eventNonInteraction: '0'
  }, (data == null ? void 0 : data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_1__["default"])(data.channel)));
};
var buildZipCodeBarClick = function buildZipCodeBarClick(_ref3) {
  var data = _ref3.data;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: 'ver-ofertas-para-minha-regiao',
    eventNonInteraction: '0'
  }, (data == null ? void 0 : data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_1__["default"])(data.channel)));
};
var buildZipCodeBarResponseError = function buildZipCodeBarResponseError(error) {
  return {
    event: 'clickEvent',
    eventAction: 'erro',
    eventCategory: eventCategory,
    eventLabel: error == null ? void 0 : error.message,
    eventNonInteraction: '0'
  };
};
var buildZipCodeBarResponseSuccess = function buildZipCodeBarResponseSuccess(_ref4) {
  var data = _ref4.data;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    event: 'clickEvent',
    eventAction: 'calcular',
    eventCategory: eventCategory,
    eventLabel: 'sucesso',
    eventNonInteraction: '1'
  }, (data == null ? void 0 : data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_1__["default"])(data.channel)));
};
var zipCodeBarClick = function zipCodeBarClick(data, args) {
  return buildZipCodeBarClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, args));
};
var zipCodeBarResponseError = function zipCodeBarResponseError(data) {
  return buildZipCodeBarResponseError(data);
};
var zipCodeBarResponseSuccess = function zipCodeBarResponseSuccess(data, args) {
  return buildZipCodeBarResponseSuccess((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, args));
};
var zipCodeBarTooltipClick = function zipCodeBarTooltipClick(data, args) {
  return buildPopupZipCodeBarClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, args, {
    eventLabel: 'preencher'
  }));
};
var zipCodeBarTooltipClose = function zipCodeBarTooltipClose(data, args) {
  return buildPopupZipCodeBarClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, args, {
    eventLabel: 'fechar'
  }));
};
var zipCodeBarTooltipSuccessView = function zipCodeBarTooltipSuccessView(data, args) {
  return buildPopupZipCodeBarImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, args, {
    eventLabel: 'tooltip:preencheu-localizacao'
  }));
};
var zipCodeBarTooltipView = function zipCodeBarTooltipView(data, args) {
  return buildPopupZipCodeBarImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, args, {
    eventLabel: 'tooltip:compartilhe-sua-localizacao'
  }));
};

/***/ }),

/***/ 33637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addToCartDimensions": function() { return /* binding */ addToCartDimensions; }
/* harmony export */ });
/* harmony import */ var _magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87302);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62624);
/* harmony import */ var _wishlistItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(988);
/* harmony import */ var _discountCalc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80746);
/* harmony import */ var _buildDimensions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6325);
/* harmony import */ var _formattedTagSelo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19175);






var buildDimension7 = function buildDimension7(priceData) {
  var price = (priceData == null ? void 0 : priceData.price) || null;
  var bestPrice = (priceData == null ? void 0 : priceData.bestPrice) || null;
  var fullPrice = (priceData == null ? void 0 : priceData.fullPrice) || null;
  return "preco-de:".concat(price !== null ? price : 'null', "|pix:").concat(bestPrice !== null ? bestPrice : 'null', "|mpay:null|boleto:").concat(fullPrice !== null ? fullPrice : 'null');
};
var buildDimension23 = function buildDimension23(seller, togglePdpSellerScore) {
  var _seller$details, _seller$details$score;
  return seller.category === '1p' || !!_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .magaluCompanies */ .p5[seller.id] ? '0' : "".concat(Number(!!togglePdpSellerScore) || '1', ":").concat(((_seller$details = seller.details) == null ? void 0 : (_seller$details$score = _seller$details.score) == null ? void 0 : _seller$details$score.toString()) || null);
};
var buildDimension41 = function buildDimension41(offerTags) {
  return "etiqueta:".concat((offerTags == null ? void 0 : offerTags.includes('magalu_indica')) ? '1:magalu-indica' : '0');
};
var buildDimension112 = function buildDimension112(shipping) {
  if (!shipping) return null;
  var standarDelivery = 'null';
  var standardDeliveryTime = 'null';
  var storePickup = 'null';
  shipping.forEach(function (item) {
    if (item.type === 'conventional') {
      standarDelivery = item.description;
      standardDeliveryTime = item.price;
    }
    if (item.type === 'store_pickup') {
      storePickup = item.description;
    }
  });
  return "entrega-padrao:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)(standarDelivery), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)(standardDeliveryTime), "|retira-loja:").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)(storePickup), ":null");
};
var addToCartDimensions = function addToCartDimensions(data) {
  var _data$product, _data$product2, _data$product2$seller, _data$product3, _data$product4, _data$product5, _data$product6, _data$product7, _data$product7$rating, _data$product7$rating2, _data$product8, _data$product8$rating, _data$product8$rating2, _data$product9, _data$product10, _data$product10$selle, _data$product11, _data$product11$selle, _data$product12, _data$product13, _data$product14, _cardanData$uiState, _buildDimension, _data$product15, _data$product15$shipp, _data$product15$shipp2, _data$product15$shipp3, _data$product15$shipp4, _data$product16, _data$product17, _data$product17$media, _data$product17$media2;
  var _formattedTagSeal = (0,_formattedTagSelo__WEBPACK_IMPORTED_MODULE_3__.formattedTagSeal)(data == null ? void 0 : data.product),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  var formattedDate = (0,_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_0__/* .fetchFormattedTime */ .bdZ)();
  var _checkAndCalculateTim = (0,_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_0__/* .checkAndCalculateTime */ .lbA)(data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.restrictions, formattedDate),
    show = _checkAndCalculateTim.show;
  var cardanData = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .getCookie */ .ej)(_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .cookiesConstants.CARDAN_TRACK_MENU */ .VD.CARDAN_TRACK_MENU);
  return {
    dimension5: (data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : (_data$product2$seller = _data$product2.seller) == null ? void 0 : _data$product2$seller.category) || null,
    dimension7: buildDimension7(data == null ? void 0 : (_data$product3 = data.product) == null ? void 0 : _data$product3.price),
    dimension8: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_2__.buildDimension8)(data),
    dimension9: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_2__.buildDimension9)(data.product),
    dimension11: "".concat((data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : _data$product4.available) ? 'verdadeiro' : 'falso:sem-estoque'),
    dimension23: buildDimension23(data == null ? void 0 : (_data$product5 = data.product) == null ? void 0 : _data$product5.seller, data == null ? void 0 : (_data$product6 = data.product) == null ? void 0 : _data$product6.togglePdpSellerScore),
    dimension24: "qtd-av:".concat(data == null ? void 0 : (_data$product7 = data.product) == null ? void 0 : (_data$product7$rating = _data$product7.rating) == null ? void 0 : (_data$product7$rating2 = _data$product7$rating.count) == null ? void 0 : _data$product7$rating2.toString(), "|av:").concat(data == null ? void 0 : (_data$product8 = data.product) == null ? void 0 : (_data$product8$rating = _data$product8.rating) == null ? void 0 : (_data$product8$rating2 = _data$product8$rating.score) == null ? void 0 : _data$product8$rating2.toString()),
    dimension40: "contagem-regressiva:".concat(show ? '1' : '0'),
    dimension41: buildDimension41(data == null ? void 0 : (_data$product9 = data.product) == null ? void 0 : _data$product9.offerTags),
    dimension61: (data == null ? void 0 : (_data$product10 = data.product) == null ? void 0 : (_data$product10$selle = _data$product10.seller) == null ? void 0 : _data$product10$selle.id) || null,
    dimension62: (data == null ? void 0 : (_data$product11 = data.product) == null ? void 0 : (_data$product11$selle = _data$product11.seller) == null ? void 0 : _data$product11$selle.deliveryId) || null,
    dimension77: "nominal:".concat((data == null ? void 0 : data.pageName) === 'buybox' ? null : (0,_discountCalc__WEBPACK_IMPORTED_MODULE_4__.getNominalDiscountValue)(data == null ? void 0 : (_data$product12 = data.product) == null ? void 0 : _data$product12.installment, data == null ? void 0 : (_data$product13 = data.product) == null ? void 0 : _data$product13.price), "|percentual:").concat((0,_discountCalc__WEBPACK_IMPORTED_MODULE_4__.getPercentualDiscountValue)(data == null ? void 0 : (_data$product14 = data.product) == null ? void 0 : _data$product14.price)),
    dimension86: seal,
    dimension87: (cardanData == null ? void 0 : (_cardanData$uiState = cardanData.uiState) == null ? void 0 : _cardanData$uiState.showSummary) ? "tag:".concat(cardanData == null ? void 0 : cardanData.compatibility) : tag,
    dimension112: (_buildDimension = buildDimension112(data == null ? void 0 : (_data$product15 = data.product) == null ? void 0 : (_data$product15$shipp = _data$product15.shipping) == null ? void 0 : (_data$product15$shipp2 = _data$product15$shipp[0]) == null ? void 0 : (_data$product15$shipp3 = _data$product15$shipp2.packages) == null ? void 0 : (_data$product15$shipp4 = _data$product15$shipp3[0]) == null ? void 0 : _data$product15$shipp4.deliveryTypes)) == null ? void 0 : _buildDimension.slice(0, 99),
    dimension115: (0,_wishlistItem__WEBPACK_IMPORTED_MODULE_5__.wishlistItem)(data == null ? void 0 : (_data$product16 = data.product) == null ? void 0 : _data$product16.variationId),
    dimension120: (data == null ? void 0 : (_data$product17 = data.product) == null ? void 0 : (_data$product17$media = _data$product17.media) == null ? void 0 : (_data$product17$media2 = _data$product17$media.images) == null ? void 0 : _data$product17$media2.length) || null
  };
};

/***/ }),

/***/ 8886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addToWishlistDimensions": function() { return /* binding */ addToWishlistDimensions; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _wishlistItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(988);
/* harmony import */ var _discountCalc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80746);
/* harmony import */ var _buildDimensions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6325);
/* harmony import */ var _formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19175);





var buildDimension7 = function buildDimension7(priceData) {
  var price = (priceData == null ? void 0 : priceData.price) || null;
  var bestPrice = (priceData == null ? void 0 : priceData.bestPrice) || null;
  var fullPrice = (priceData == null ? void 0 : priceData.fullPrice) || null;
  return "preco-de:".concat(price !== null ? price : 'null', "|pix:").concat(bestPrice !== null ? bestPrice : 'null', "|mpay:null|boleto:").concat(fullPrice !== null ? fullPrice : 'null');
};
var buildDimension23 = function buildDimension23(seller, togglePdpSellerScore) {
  var _seller$details, _seller$details$score;
  return seller.category === '1p' || !!_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .magaluCompanies */ .p5[seller.id] ? '0' : "".concat(Number(!!togglePdpSellerScore) || '1', ":").concat(((_seller$details = seller.details) == null ? void 0 : (_seller$details$score = _seller$details.score) == null ? void 0 : _seller$details$score.toString()) || null);
};
var buildDimension41 = function buildDimension41(offerTags) {
  return "etiqueta:".concat((offerTags == null ? void 0 : offerTags.includes('magalu_indica')) ? '1:magalu-indica' : '0');
};
var buildDimension112 = function buildDimension112(shippingTag) {
  if (!shippingTag) return "entrega-padr\xE3o:null:null|retira-loja:null";
  var cost = (shippingTag == null ? void 0 : shippingTag.cost) === 0 ? 0 : shippingTag.cost || 'null';
  var timeSlug = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((shippingTag == null ? void 0 : shippingTag.time) || 'null');
  var complementSlug = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((shippingTag == null ? void 0 : shippingTag.complement) || 'null');
  return "entrega-padr\xE3o:".concat(timeSlug || null, ":").concat(cost || null, "|retira-loja:").concat(complementSlug || null, ":").concat(shippingTag.source || null);
};
var addToWishlistDimensions = function addToWishlistDimensions(data) {
  var _data$seller, _data$rating, _data$rating$count, _data$rating2, _data$rating2$score, _data$seller2, _data$seller3, _cardanData$uiState, _buildDimension, _data$media, _data$media$images;
  var _formattedTagSeal = (0,_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__.formattedTagSeal)(data),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  var cardanData = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .cookiesConstants.CARDAN_TRACK_MENU */ .VD.CARDAN_TRACK_MENU);
  return {
    dimension5: (data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.category) || null,
    dimension7: buildDimension7(data == null ? void 0 : data.price),
    dimension8: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_1__.buildDimension8)(data),
    dimension9: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_1__.buildDimension9)(data),
    dimension11: "".concat((data == null ? void 0 : data.available) ? 'verdadeiro' : 'falso:indisponivel-cep'),
    dimension23: buildDimension23(data == null ? void 0 : data.seller, data == null ? void 0 : data.togglePdpSellerScore),
    dimension24: "qtd-av:".concat(data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : (_data$rating$count = _data$rating.count) == null ? void 0 : _data$rating$count.toString(), "|av:").concat(data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : (_data$rating2$score = _data$rating2.score) == null ? void 0 : _data$rating2$score.toString()),
    dimension40: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_1__.buildDimension40)(data),
    dimension41: buildDimension41(data == null ? void 0 : data.offerTags),
    dimension61: (data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.id) || null,
    dimension62: (data == null ? void 0 : (_data$seller3 = data.seller) == null ? void 0 : _data$seller3.deliveryId) || null,
    dimension77: "nominal:".concat((0,_discountCalc__WEBPACK_IMPORTED_MODULE_3__.getNominalDiscountValue)(data == null ? void 0 : data.installment, data == null ? void 0 : data.price), "|percentual:").concat((0,_discountCalc__WEBPACK_IMPORTED_MODULE_3__.getPercentualDiscountValue)(data == null ? void 0 : data.price)),
    dimension80: (data == null ? void 0 : data.pageName) === 'busca' ? (data == null ? void 0 : data.term) || null : null,
    dimension86: seal,
    dimension87: (cardanData == null ? void 0 : (_cardanData$uiState = cardanData.uiState) == null ? void 0 : _cardanData$uiState.showSummary) ? "tag:".concat(cardanData == null ? void 0 : cardanData.compatibility) : tag,
    dimension103: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_1__.buildDimension103)(data),
    dimension112: (_buildDimension = buildDimension112(data == null ? void 0 : data.shippingTag)) == null ? void 0 : _buildDimension.slice(0, 99),
    dimension115: (0,_wishlistItem__WEBPACK_IMPORTED_MODULE_4__.wishlistItem)(data == null ? void 0 : data.variationId),
    dimension120: (data == null ? void 0 : (_data$media = data.media) == null ? void 0 : (_data$media$images = _data$media.images) == null ? void 0 : _data$media$images.length) || null
  };
};

/***/ }),

/***/ 6325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildDimension103": function() { return /* binding */ buildDimension103; },
/* harmony export */   "buildDimension40": function() { return /* binding */ buildDimension40; },
/* harmony export */   "buildDimension8": function() { return /* binding */ buildDimension8; },
/* harmony export */   "buildDimension9": function() { return /* binding */ buildDimension9; }
/* harmony export */ });
/* harmony import */ var _magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87302);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62624);


var buildDimension103 = function buildDimension103(data) {
  var _data$ads;
  if ((data == null ? void 0 : data.campaignId) || (data == null ? void 0 : (_data$ads = data.ads) == null ? void 0 : _data$ads.campaignId)) {
    return 'ads';
  }
  return (data == null ? void 0 : data.origin) || 'null';
};
var buildDimension40 = function buildDimension40(data) {
  var restrictions = data.restrictions;
  if (!restrictions) return "contagem-regressiva:0";
  var formattedDate = (0,_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_0__/* .fetchFormattedTime */ .bdZ)();
  var _checkAndCalculateTim = (0,_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_0__/* .checkAndCalculateTime */ .lbA)(restrictions, formattedDate),
    show = _checkAndCalculateTim.show;
  return "contagem-regressiva:".concat(show ? '1' : '0');
};
var buildDimension8 = function buildDimension8(data) {
  var _data$product, _previousInstallment, _previousInstallment2, _previousInstallment3, _data$product2, _data$product2$instal, _data$installment, _data$product3, _data$product3$instal, _data$installment2, _data$product4, _data$product4$instal, _data$installment3;
  if ((data == null ? void 0 : data.pageName) === 'buybox') {
    return "cartao-luiza:null:null:null|cartao-credito:null:null:null";
  }
  var paymentMethods = (data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.paymentMethods) || (data == null ? void 0 : data.paymentMethods);
  var luizaOuroMethod = paymentMethods == null ? void 0 : paymentMethods.find(function (method) {
    return method.id === 'luiza_ouro';
  });
  var installmentPlans = (luizaOuroMethod == null ? void 0 : luizaOuroMethod.installmentPlans) || [];
  var previousInstallment = null;
  installmentPlans.find(function (currentInstallment) {
    if (currentInstallment.interest !== '0.00') {
      return true;
    }
    previousInstallment = currentInstallment;
    return false;
  });
  var luizaCardTotalAmount = ((_previousInstallment = previousInstallment) == null ? void 0 : _previousInstallment.totalAmount) || null;
  var luizaCardInstallmentLength = ((_previousInstallment2 = previousInstallment) == null ? void 0 : _previousInstallment2.installment) || null;
  var luizaCardLastInstallmentAmount = ((_previousInstallment3 = previousInstallment) == null ? void 0 : _previousInstallment3.installmentAmount) || null;
  var creditCardTotalAmount = (data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : (_data$product2$instal = _data$product2.installment) == null ? void 0 : _data$product2$instal.totalAmount) || (data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.totalAmount) || null;
  var creditCardQuantity = (data == null ? void 0 : (_data$product3 = data.product) == null ? void 0 : (_data$product3$instal = _data$product3.installment) == null ? void 0 : _data$product3$instal.quantity) || (data == null ? void 0 : (_data$installment2 = data.installment) == null ? void 0 : _data$installment2.quantity) || null;
  var creditCardAmount = (data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : (_data$product4$instal = _data$product4.installment) == null ? void 0 : _data$product4$instal.amount) || (data == null ? void 0 : (_data$installment3 = data.installment) == null ? void 0 : _data$installment3.amount) || null;
  return "cartao-luiza:".concat(luizaCardTotalAmount, ":").concat(luizaCardInstallmentLength, ":").concat(luizaCardLastInstallmentAmount, "|cartao-credito:").concat(creditCardTotalAmount, ":").concat(creditCardQuantity, ":").concat(creditCardAmount);
};
var formatValue = function formatValue(value) {
  return value ? parseFloat(value).toFixed(2) : 'nao-calculado';
};
var buildDimension9 = function buildDimension9(product) {
  var _product$tax, _product$tax2;
  if (!(0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .isInternationalPrice */ .xx)(product)) {
    return null;
  }
  var icms = formatValue(product == null ? void 0 : (_product$tax = product.tax) == null ? void 0 : _product$tax.icms);
  var importTax = formatValue(product == null ? void 0 : (_product$tax2 = product.tax) == null ? void 0 : _product$tax2.importValue);
  return "imposto:".concat(importTax, "|icms:").concat(icms);
};

/***/ }),

/***/ 45842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _dataLayerPushQueue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60604);



var dataLayerPush = function dataLayerPush(listener) {
  return function () {
    var _structure$config;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var _ref = args[args.length - 1] || {},
      config = _ref.config,
      structure = _ref.structure;
    var isDevelopment = (config == null ? void 0 : config.environment) === 'development';
    if (!listener || _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .whereAmI.onServer */ .er.onServer || !window.dataLayer || !document) return;
    var data = listener.apply(void 0, args);
    if (!data) {
      if (isDevelopment) {
        console.warn('[dataLayer.push]: ocorreu uma tentativa de envio de evento sem dados', args);
      }
      return;
    }
    var finalData = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data, {
      hitTimestamp: new Date().getTime()
    });
    if (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.isMiniApp) {
      (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .useFirebasePush */ .Gz)(finalData);
    } else {
      (0,_dataLayerPushQueue__WEBPACK_IMPORTED_MODULE_2__.dataLayerPushWithQueue)(finalData);
    }
    if ((config == null ? void 0 : config.environment) === 'development') {
      var listnerResult = listener.apply(void 0, args);
      if (listnerResult) {
        var event = listnerResult.event,
          eventCategory = listnerResult.eventCategory,
          pageType = listnerResult.pageType,
          contentType = listnerResult.content_type;
        var title = "%c[ga log] ".concat(eventCategory || pageType || contentType, " ").concat(event, "\n");
        console.groupCollapsed(title, 'color: #03A9F4');
        console.log("\uD83D\uDCE1 [dataLayer.push]", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, listener.apply(void 0, args)));
        console.groupEnd(title);
      }
    }
  };
};
/* harmony default export */ __webpack_exports__["default"] = (dataLayerPush);

/***/ }),

/***/ 60604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dataLayerPushWithQueue": function() { return /* binding */ dataLayerPushWithQueue; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85942);

var dataLayerPushWithQueue = function dataLayerPushWithQueue(data) {
  var _window2, _window2$dlcmglu, _window2$dlcmglu$cach;
  var usePriorityQueue = "production" === 'production';
  if (!usePriorityQueue) {
    var _window, _window$dataLayer;
    (_window = window) == null ? void 0 : (_window$dataLayer = _window.dataLayer) == null ? void 0 : _window$dataLayer.push(data);
    return;
  }
  var cacheKey = window.location.pathname;
  window.dlcmglu = window.dlcmglu || {};
  window.dlcmglu[cacheKey] = window.dlcmglu[cacheKey] || {
    list: [],
    seen: false
  };
  if ((_window2 = window) == null ? void 0 : (_window2$dlcmglu = _window2.dlcmglu) == null ? void 0 : (_window2$dlcmglu$cach = _window2$dlcmglu[cacheKey]) == null ? void 0 : _window2$dlcmglu$cach.seen) {
    var _window3, _window3$dataLayer;
    (_window3 = window) == null ? void 0 : (_window3$dataLayer = _window3.dataLayer) == null ? void 0 : _window3$dataLayer.push(data);
    return;
  }
  var hasPriority = (data == null ? void 0 : data.event) === 'virtualPageview';
  if (!hasPriority) {
    var _window4, _window4$dlcmglu;
    (_window4 = window) == null ? void 0 : (_window4$dlcmglu = _window4.dlcmglu) == null ? void 0 : _window4$dlcmglu[cacheKey].list.push(data);
  } else {
    var _window5, _window5$dataLayer, _window6, _window7, _window7$dlcmglu;
    (_window5 = window) == null ? void 0 : (_window5$dataLayer = _window5.dataLayer) == null ? void 0 : _window5$dataLayer.push(data);
    if (((_window6 = window) == null ? void 0 : _window6.dataLayer) && ((_window7 = window) == null ? void 0 : (_window7$dlcmglu = _window7.dlcmglu) == null ? void 0 : _window7$dlcmglu[cacheKey].list)) {
      var _window8, _window8$dataLayer, _window9, _window9$dlcmglu;
      (_window8 = window) == null ? void 0 : (_window8$dataLayer = _window8.dataLayer) == null ? void 0 : _window8$dataLayer.push.apply(_window8$dataLayer, (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((_window9 = window) == null ? void 0 : (_window9$dlcmglu = _window9.dlcmglu) == null ? void 0 : _window9$dlcmglu[cacheKey].list));
      window.dlcmglu[cacheKey] = {
        list: [],
        seen: true
      };
    }
  }
};

/***/ }),

/***/ 80746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getNominalDiscountValue": function() { return /* binding */ getNominalDiscountValue; },
/* harmony export */   "getPercentualDiscountValue": function() { return /* binding */ getPercentualDiscountValue; }
/* harmony export */ });
var getNominalDiscountValue = function getNominalDiscountValue(installment, price) {
  if ((installment == null ? void 0 : installment.totalAmount) && (price == null ? void 0 : price.bestPrice)) {
    return parseFloat(((installment == null ? void 0 : installment.totalAmount) - (price == null ? void 0 : price.bestPrice)).toFixed(2));
  }
  if ((price == null ? void 0 : price.bestPrice) && (price == null ? void 0 : price.fullPrice)) {
    return parseFloat(((price == null ? void 0 : price.fullPrice) - (price == null ? void 0 : price.bestPrice)).toFixed(2));
  }
  return null;
};
var getPercentualDiscountValue = function getPercentualDiscountValue(price) {
  return (price == null ? void 0 : price.discount) || 'null';
};

/***/ }),

/***/ 19175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "formattedTagSeal": function() { return /* binding */ formattedTagSeal; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var hasKey = function hasKey() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = arguments.length > 1 ? arguments[1] : undefined;
  return Object.prototype.hasOwnProperty.call(obj, key);
};
var getCouponTag = function getCouponTag(product) {
  var _product$seller, _product$seller$tags;
  var coupon = product == null ? void 0 : (_product$seller = product.seller) == null ? void 0 : (_product$seller$tags = _product$seller.tags) == null ? void 0 : _product$seller$tags.find(function (tag) {
    return tag.type === 'coupon';
  });
  if (!coupon) return null;
  var discountLabels = {
    absolute: 'R$',
    percentage: '%'
  };
  var currentDiscount = discountLabels[coupon.discountType];
  return "cupom-".concat(coupon.discountValue, "-").concat(currentDiscount, "-off");
};
var getOfferTag = function getOfferTag(product) {
  var _product$offerTags, _product$offerTags$;
  var noTag = 'sem-tag';
  var hasOfferTags = hasKey(product, 'offerTags');
  return hasOfferTags ? "".concat(((_product$offerTags = product.offerTags) == null ? void 0 : (_product$offerTags$ = _product$offerTags[0]) == null ? void 0 : _product$offerTags$.replace(/_/g, '-')) || noTag) : null;
};
var getInternationalTag = function getInternationalTag(product) {
  return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .isInternationalPrice */ .xx)(product) ? 'compra-internacional' : null;
};
var getBadgeSeal = function getBadgeSeal(product) {
  var _product$badges, _product$badges$;
  var noSeal = 'sem-selo';
  var hasBadges = hasKey(product, 'badges');
  return hasBadges ? "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)((_product$badges = product.badges) == null ? void 0 : (_product$badges$ = _product$badges[0]) == null ? void 0 : _product$badges$.text) || noSeal) : null;
};
var formattedTagSeal = function formattedTagSeal(product) {
  var offerTag = getOfferTag(product);
  var internationalTag = getInternationalTag(product);
  var badgeSeal = getBadgeSeal(product);
  var couponTag = getCouponTag(product);
  var tag = [offerTag, internationalTag, couponTag].filter(Boolean).join('|') || null;
  return {
    seal: badgeSeal,
    tag: tag
  };
};

/***/ }),

/***/ 58338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "itemVariantParser": function() { return /* binding */ itemVariantParser; }
/* harmony export */ });
var itemVariantParser = function itemVariantParser(attributes) {
  if (!attributes || !Array.isArray(attributes)) {
    return '';
  }
  var values = attributes.map(function (item) {
    var tipo = item.type || '';
    var valor = item.value || '';
    return [tipo, valor].filter(Boolean).join(':');
  }).filter(Boolean).join('|');
  return values.replace(/[_\s]/g, '-').replace(/,(?:-\s*)/g, ',').toLowerCase();
};

/***/ }),

/***/ 62322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "parseUrl": function() { return /* binding */ parseUrl; }
/* harmony export */ });
var parseUrl = function parseUrl(data, position) {
  var _data$split, _data$split$;
  if (!data) {
    return null;
  }
  return data == null ? void 0 : (_data$split = data.split('/p/')) == null ? void 0 : (_data$split$ = _data$split[1]) == null ? void 0 : _data$split$.split('/')[position];
};

/***/ }),

/***/ 12608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "selectItemDimensions": function() { return /* binding */ selectItemDimensions; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _wishlistItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(988);
/* harmony import */ var _discountCalc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80746);
/* harmony import */ var _formattedTagSelo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19175);
/* harmony import */ var _buildDimensions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6325);





var buildDimension7 = function buildDimension7(priceData) {
  var price = (priceData == null ? void 0 : priceData.price) || null;
  var bestPrice = (priceData == null ? void 0 : priceData.bestPrice) || null;
  var fullPrice = (priceData == null ? void 0 : priceData.fullPrice) || null;
  return "preco-de:".concat(price !== null ? price : 'null', "|pix:").concat(bestPrice !== null ? bestPrice : 'null', "|mpay:null|boleto:").concat(fullPrice !== null ? fullPrice : 'null');
};
var buildDimension11 = function buildDimension11(data) {
  var _data$product;
  return (data == null ? void 0 : data.available) || (data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.available) ? 'verdadeiro' : 'falso:sem-estoque';
};
var buildDimension23 = function buildDimension23(seller, togglePdpSellerScore) {
  var _seller$details, _seller$details$score;
  return seller.category === '1p' || !!_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .magaluCompanies */ .p5[seller.id] ? '0' : "".concat(Number(!!togglePdpSellerScore) || '1', ":").concat(((_seller$details = seller.details) == null ? void 0 : (_seller$details$score = _seller$details.score) == null ? void 0 : _seller$details$score.toString()) || null);
};
var buildDimension41 = function buildDimension41(offerTags) {
  return "etiqueta:".concat((offerTags == null ? void 0 : offerTags.includes('magalu_indica')) ? '1:magalu-indica' : '0');
};
var buildDimension4 = function buildDimension4(data) {
  var _ref, _data$ads;
  return (_ref = (data == null ? void 0 : data.campaignId) || (data == null ? void 0 : (_data$ads = data.ads) == null ? void 0 : _data$ads.campaignId)) !== null && _ref !== void 0 ? _ref : null;
};
var buildDimension45 = function buildDimension45(data) {
  var _data$isBuyBox;
  var isBuyBox = (_data$isBuyBox = data == null ? void 0 : data.isBuyBox) !== null && _data$isBuyBox !== void 0 ? _data$isBuyBox : false;
  var isSponsored = !!(data == null ? void 0 : data.ads);
  var adsValue = "ads:".concat(isSponsored ? '1' : '0');
  return isBuyBox ? "1|".concat(adsValue) : "0|".concat(adsValue);
};
var buildDimension112 = function buildDimension112(shippingTag) {
  if (!shippingTag) return null;
  var cost = (shippingTag == null ? void 0 : shippingTag.cost) === 0 ? 0 : shippingTag == null ? void 0 : shippingTag.cost;
  var timeSlug = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((shippingTag == null ? void 0 : shippingTag.time) || '');
  var complementSlug = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((shippingTag == null ? void 0 : shippingTag.complement) || '');
  var sourceValue = shippingTag == null ? void 0 : shippingTag.source;
  var deliveryString = "entrega-padr\xE3o:".concat(timeSlug || null, ":").concat(cost === 0 ? 'frete-gratis' : cost || null, "|retira-loja:").concat(complementSlug || null, ":").concat(sourceValue || null);
  return deliveryString.slice(0, 99) || null;
};
var selectItemDimensions = function selectItemDimensions(data) {
  var _data$seller, _data$installment$tot, _data$installment, _data$installment$qua, _data$installment2, _data$installment$amo, _data$installment3, _data$rating, _data$rating$count, _data$rating2, _data$rating2$score, _data$seller2, _data$seller3, _data$parsedAttribute, _data$parsedAttribute2, _data$parsedAttribute3, _data$parsedAttribute4, _data$parsedAttribute5, _data$parsedAttribute6, _data$showcase, _data$showcase2, _data$showcase3, _data$showcase4, _data$shippingTag;
  var _formattedTagSeal = (0,_formattedTagSelo__WEBPACK_IMPORTED_MODULE_1__.formattedTagSeal)(data),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  return {
    dimension4: buildDimension4(data),
    dimension5: (data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.category) || null,
    dimension7: buildDimension7(data == null ? void 0 : data.price),
    dimension8: "cartao-luiza:null:null:null|cartao-credito:".concat((_data$installment$tot = data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.totalAmount) !== null && _data$installment$tot !== void 0 ? _data$installment$tot : null, ":").concat((_data$installment$qua = data == null ? void 0 : (_data$installment2 = data.installment) == null ? void 0 : _data$installment2.quantity) !== null && _data$installment$qua !== void 0 ? _data$installment$qua : null, ":").concat((_data$installment$amo = data == null ? void 0 : (_data$installment3 = data.installment) == null ? void 0 : _data$installment3.amount) !== null && _data$installment$amo !== void 0 ? _data$installment$amo : null),
    dimension11: buildDimension11(data),
    dimension23: buildDimension23(data == null ? void 0 : data.seller, data == null ? void 0 : data.togglePdpSellerScore),
    dimension24: "qtd-av:".concat(data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : (_data$rating$count = _data$rating.count) == null ? void 0 : _data$rating$count.toString(), "|av:").concat(data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : (_data$rating2$score = _data$rating2.score) == null ? void 0 : _data$rating2$score.toString()),
    dimension40: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_2__.buildDimension40)(data),
    dimension41: buildDimension41(data == null ? void 0 : data.offerTags),
    dimension45: buildDimension45(data),
    dimension61: (data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.id) || null,
    dimension62: (data == null ? void 0 : (_data$seller3 = data.seller) == null ? void 0 : _data$seller3.deliveryId) || null,
    dimension74: "".concat(data == null ? void 0 : (_data$parsedAttribute = data.parsedAttributes) == null ? void 0 : (_data$parsedAttribute2 = _data$parsedAttribute[0]) == null ? void 0 : (_data$parsedAttribute3 = _data$parsedAttribute2.values) == null ? void 0 : _data$parsedAttribute3.length, ":").concat(data == null ? void 0 : (_data$parsedAttribute4 = data.parsedAttributes) == null ? void 0 : (_data$parsedAttribute5 = _data$parsedAttribute4[0]) == null ? void 0 : (_data$parsedAttribute6 = _data$parsedAttribute5.values) == null ? void 0 : _data$parsedAttribute6.toString()),
    dimension77: "nominal:".concat((0,_discountCalc__WEBPACK_IMPORTED_MODULE_3__.getNominalDiscountValue)(data == null ? void 0 : data.installment, data == null ? void 0 : data.price), "|percentual:").concat((0,_discountCalc__WEBPACK_IMPORTED_MODULE_3__.getPercentualDiscountValue)(data == null ? void 0 : data.price)),
    dimension80: (data == null ? void 0 : data.pageName) === 'busca' ? (data == null ? void 0 : data.term) || null : null,
    dimension86: seal,
    dimension87: tag,
    dimension103: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_2__.buildDimension103)(data),
    dimension106: "alg:".concat((data == null ? void 0 : (_data$showcase = data.showcase) == null ? void 0 : _data$showcase.pageId) || (data == null ? void 0 : data.pageName) || 'null', "-").concat((data == null ? void 0 : (_data$showcase2 = data.showcase) == null ? void 0 : _data$showcase2.placeId) || 'null', "-").concat((data == null ? void 0 : (_data$showcase3 = data.showcase) == null ? void 0 : _data$showcase3.id) || 'null', "|type:").concat((data == null ? void 0 : (_data$showcase4 = data.showcase) == null ? void 0 : _data$showcase4.type) || (data == null ? void 0 : data.displayMode) || 'null'),
    dimension112: buildDimension112(data == null ? void 0 : data.shippingTag),
    dimension115: (0,_wishlistItem__WEBPACK_IMPORTED_MODULE_4__.wishlistItem)(data == null ? void 0 : data.variationId),
    dimension121: (data == null ? void 0 : (_data$shippingTag = data.shippingTag) == null ? void 0 : _data$shippingTag.uuid) || 'null'
  };
};

/***/ }),

/***/ 87191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "viewItemDimensions": function() { return /* binding */ viewItemDimensions; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _wishlistItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(988);
/* harmony import */ var _discountCalc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80746);
/* harmony import */ var _buildDimensions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6325);
/* harmony import */ var _formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19175);





var buildDimension7 = function buildDimension7(priceData) {
  var price = (priceData == null ? void 0 : priceData.price) || null;
  var bestPrice = (priceData == null ? void 0 : priceData.bestPrice) || null;
  var fullPrice = (priceData == null ? void 0 : priceData.fullPrice) || null;
  return "preco-de:".concat(price !== null ? price : 'null', "|pix:").concat(bestPrice !== null ? bestPrice : 'null', "|mpay:null|boleto:").concat(fullPrice !== null ? fullPrice : 'null');
};
var buildDimension23 = function buildDimension23(seller, togglePdpSellerScore) {
  var _seller$details, _seller$details$score;
  return seller.category === '1p' || !!_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .magaluCompanies */ .p5[seller.id] ? '0' : "".concat(Number(!!togglePdpSellerScore) || '1', ":").concat(((_seller$details = seller.details) == null ? void 0 : (_seller$details$score = _seller$details.score) == null ? void 0 : _seller$details$score.toString()) || null);
};
var buildDimension41 = function buildDimension41(offerTags) {
  return "etiqueta:".concat((offerTags == null ? void 0 : offerTags.includes('magalu_indica')) ? '1:magalu-indica' : '0');
};
var buildDimension112 = function buildDimension112(shipping) {
  if (!shipping) return null;
  var standarDelivery = 'null';
  var standardDeliveryTime = 'null';
  var storePickup = 'null';
  shipping.forEach(function (item) {
    if (item.type === 'conventional') {
      var _item$shippingTime, _item$cost;
      standarDelivery = item == null ? void 0 : (_item$shippingTime = item.shippingTime) == null ? void 0 : _item$shippingTime.description;
      standardDeliveryTime = item == null ? void 0 : (_item$cost = item.cost) == null ? void 0 : _item$cost.customer;
    }
    if (item.type === 'store_pickup') {
      var _item$shippingTime2;
      storePickup = item == null ? void 0 : (_item$shippingTime2 = item.shippingTime) == null ? void 0 : _item$shippingTime2.description;
    }
  });
  var deliveryString = "entrega-padrao:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(standarDelivery) || null, ":").concat(standardDeliveryTime || 0, "|retira-loja:").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(storePickup) || null, ":null");
  return deliveryString.slice(0, 99) || null;
};
var viewItemDimensions = function viewItemDimensions(data) {
  var _data$product, _data$product$seller, _data$product2, _data$product3, _data$product4, _data$structure, _data$product5, _data$product5$rating, _data$product5$rating2, _data$product6, _data$product6$rating, _data$product6$rating2, _data$product7, _data$product8, _data$product8$seller, _data$product9, _data$product9$seller, _data$product10, _data$product11, _data$product12, _data$deliveries, _data$deliveries$, _data$product13, _data$product14, _data$product14$media, _data$product14$media2;
  var _formattedTagSeal = (0,_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__.formattedTagSeal)(data == null ? void 0 : data.product),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  return {
    dimension5: (data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$seller = _data$product.seller) == null ? void 0 : _data$product$seller.category) || null,
    dimension7: buildDimension7(data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : _data$product2.price),
    dimension8: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_1__.buildDimension8)(data),
    dimension11: "".concat((data == null ? void 0 : (_data$product3 = data.product) == null ? void 0 : _data$product3.available) ? 'verdadeiro' : 'falso:sem-estoque'),
    dimension23: buildDimension23(data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : _data$product4.seller, data == null ? void 0 : (_data$structure = data.structure) == null ? void 0 : _data$structure.togglePdpSellerScore),
    dimension24: "qtd-av:".concat(data == null ? void 0 : (_data$product5 = data.product) == null ? void 0 : (_data$product5$rating = _data$product5.rating) == null ? void 0 : (_data$product5$rating2 = _data$product5$rating.count) == null ? void 0 : _data$product5$rating2.toString(), "|av:").concat(data == null ? void 0 : (_data$product6 = data.product) == null ? void 0 : (_data$product6$rating = _data$product6.rating) == null ? void 0 : (_data$product6$rating2 = _data$product6$rating.score) == null ? void 0 : _data$product6$rating2.toString()),
    dimension40: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_1__.buildDimension40)(data == null ? void 0 : data.product),
    dimension41: buildDimension41(data == null ? void 0 : (_data$product7 = data.product) == null ? void 0 : _data$product7.offerTags),
    dimension61: (data == null ? void 0 : (_data$product8 = data.product) == null ? void 0 : (_data$product8$seller = _data$product8.seller) == null ? void 0 : _data$product8$seller.id) || null,
    dimension62: (data == null ? void 0 : (_data$product9 = data.product) == null ? void 0 : (_data$product9$seller = _data$product9.seller) == null ? void 0 : _data$product9$seller.deliveryId) || null,
    dimension77: "nominal:".concat((0,_discountCalc__WEBPACK_IMPORTED_MODULE_3__.getNominalDiscountValue)(data == null ? void 0 : (_data$product10 = data.product) == null ? void 0 : _data$product10.installment, data == null ? void 0 : (_data$product11 = data.product) == null ? void 0 : _data$product11.price), "|percentual:").concat((0,_discountCalc__WEBPACK_IMPORTED_MODULE_3__.getPercentualDiscountValue)(data == null ? void 0 : (_data$product12 = data.product) == null ? void 0 : _data$product12.price)),
    dimension86: seal,
    dimension87: tag,
    dimension112: buildDimension112(data == null ? void 0 : (_data$deliveries = data.deliveries) == null ? void 0 : (_data$deliveries$ = _data$deliveries[0]) == null ? void 0 : _data$deliveries$.modalities),
    dimension115: (0,_wishlistItem__WEBPACK_IMPORTED_MODULE_4__.wishlistItem)(data == null ? void 0 : (_data$product13 = data.product) == null ? void 0 : _data$product13.variationId),
    dimension120: (data == null ? void 0 : (_data$product14 = data.product) == null ? void 0 : (_data$product14$media = _data$product14.media) == null ? void 0 : (_data$product14$media2 = _data$product14$media.images) == null ? void 0 : _data$product14$media2.length) || null
  };
};

/***/ }),

/***/ 988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wishlistItem": function() { return /* binding */ wishlistItem; }
/* harmony export */ });
var wishlistItem = function wishlistItem(data) {
  var wishlistData = JSON.parse(localStorage.getItem('wishlist') || null);
  if (!wishlistData) {
    return 0;
  }
  var prodId = data;
  return wishlistData.items.some(function (item) {
    return item.id === prodId;
  }) ? 1 : 0;
};

/***/ })

}]);